{
  "level": "cc02",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:cc02",
    "objects": "AREAS.E3:cc02.e3",
    "mesh": "TREES.E3:cc02.e3"
  },
  "spawn_point": {
    "position": [
      -882.5994875261963,
      2548.4857305671503,
      -276.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      -882.5994875261963,
      2648.4857305671503,
      -276.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -6158.31884765625,
      -5033.93603515625,
      -300.0
    ],
    "bbox_max": [
      7800.0,
      7450.0,
      1961.4566650390625
    ],
    "vertex_count": 2411,
    "vertices": [
      [
        -3714.042724609375,
        -2323.521484375,
        1179.1292724609375
      ],
      [
        -5545.388671875,
        4741.15380859375,
        334.12225341796875
      ],
      [
        -6158.31884765625,
        3750.891357421875,
        976.300048828125
      ],
      [
        -5532.3203125,
        4687.76513671875,
        347.8643493652344
      ],
      [
        -5504.7001953125,
        4729.1015625,
        -22.699951171875
      ],
      [
        -3697.7392578125,
        -2384.4521484375,
        1181.5667724609375
      ],
      [
        -3709.58251953125,
        -2363.246337890625,
        1182.9832763671875
      ],
      [
        -3605.362548828125,
        -2269.30224609375,
        2.0755867958068848
      ],
      [
        -3614.939453125,
        -3588.4169921875,
        1317.599365234375
      ],
      [
        -4205.0,
        -2619.44677734375,
        1400.274658203125
      ],
      [
        -3461.15576171875,
        -4521.4228515625,
        1390.116943359375
      ],
      [
        -3093.3369140625,
        -4604.0595703125,
        1170.251708984375
      ],
      [
        -3095.20947265625,
        -4636.2900390625,
        1271.65087890625
      ],
      [
        -3071.5029296875,
        -4634.1865234375,
        1040.098388671875
      ],
      [
        -3093.3369140625,
        -4604.0595703125,
        1170.2518310546875
      ],
      [
        -3412.67578125,
        -3448.206787109375,
        1220.0
      ],
      [
        -3411.630126953125,
        -3453.730224609375,
        1224.3428955078125
      ],
      [
        -3502.183349609375,
        -3576.798583984375,
        1274.598876953125
      ],
      [
        -3502.183349609375,
        -3576.798583984375,
        1274.598876953125
      ],
      [
        -3614.939453125,
        -3588.4169921875,
        1317.599365234375
      ],
      [
        -3605.362548828125,
        -2269.30224609375,
        2.0755615234375
      ],
      [
        -3709.58251953125,
        -2363.246337890625,
        1182.983154296875
      ],
      [
        -3714.01416015625,
        -2323.6279296875,
        1179.1334228515625
      ],
      [
        -5704.54443359375,
        4430.01318359375,
        976.300048828125
      ],
      [
        -5573.556640625,
        4626.0498046875,
        901.1133422851562
      ],
      [
        -5174.01171875,
        5224.01171875,
        -11.83930492401123
      ],
      [
        -5532.3203125,
        4687.76513671875,
        347.8642578125
      ],
      [
        -5174.01171875,
        5224.01171875,
        -11.83929443359375
      ],
      [
        -5158.470703125,
        5234.39599609375,
        -22.699951171875
      ],
      [
        -4474.53173828125,
        4475.62646484375,
        150.0
      ],
      [
        -5174.01171875,
        5224.01171875,
        41.1290283203125
      ],
      [
        -5342.2373046875,
        4972.244140625,
        157.0413818359375
      ],
      [
        -5174.01171875,
        5224.01171875,
        41.12896728515625
      ],
      [
        -5020.71826171875,
        5326.439453125,
        -22.699951171875
      ],
      [
        -5174.01171875,
        5224.01171875,
        671.77490234375
      ],
      [
        -5174.01171875,
        5224.01171875,
        671.7750244140625
      ],
      [
        -4901.68505859375,
        5405.974609375,
        546.6460571289062
      ],
      [
        -4485.7236328125,
        5683.9111328125,
        -0.0005645751953125
      ],
      [
        -4478.6357421875,
        5688.64697265625,
        -22.699951171875
      ],
      [
        -3861.63232421875,
        2261.417236328125,
        -300.0
      ],
      [
        -4468.451171875,
        5695.4521484375,
        -22.699951171875
      ],
      [
        -3179.908447265625,
        3702.748046875,
        150.0
      ],
      [
        -2916.739501953125,
        3191.2431640625,
        124.09432983398438
      ],
      [
        -2650.5576171875,
        3351.36181640625,
        4.240765571594238
      ],
      [
        -2916.739501953125,
        3191.2431640625,
        124.09432983398438
      ],
      [
        -2638.939453125,
        3351.18505859375,
        0.0
      ],
      [
        -2650.5576171875,
        3351.36181640625,
        4.2407684326171875
      ],
      [
        -2638.939453125,
        3351.18505859375,
        0.0
      ],
      [
        -2609.847900390625,
        3350.7421875,
        -10.6187744140625
      ],
      [
        -2501.9697265625,
        3265.2880859375,
        -300.0
      ],
      [
        -1156.463623046875,
        -2051.8349609375,
        202.6451416015625
      ],
      [
        -200.806640625,
        -3123.862548828125,
        0.0
      ],
      [
        -1942.9771728515625,
        -3113.202392578125,
        638.1046142578125
      ],
      [
        -2286.8662109375,
        -3329.22607421875,
        794.213623046875
      ],
      [
        -2314.744140625,
        -5033.93603515625,
        1040.098388671875
      ],
      [
        -2912.14697265625,
        -4693.75146484375,
        1212.3890380859375
      ],
      [
        -2912.14697265625,
        -4693.75146484375,
        1212.388916015625
      ],
      [
        -1700.7498779296875,
        -2507.029541015625,
        -300.0
      ],
      [
        -2808.593505859375,
        -3513.30859375,
        1011.1946411132812
      ],
      [
        -2908.152099609375,
        -3548.43603515625,
        1052.5999755859375
      ],
      [
        -3058.93505859375,
        -3479.345703125,
        1098.404052734375
      ],
      [
        -3009.681640625,
        -3300.586181640625,
        1055.611572265625
      ],
      [
        -3403.8046875,
        -3443.094970703125,
        1220.0
      ],
      [
        -3714.02197265625,
        -2323.558349609375,
        1179.126708984375
      ],
      [
        -2286.865966796875,
        -3329.22607421875,
        794.213623046875
      ],
      [
        -3697.488525390625,
        -2384.901123046875,
        1181.5367431640625
      ],
      [
        -2981.017578125,
        -3196.55322265625,
        1030.70751953125
      ],
      [
        -2981.017578125,
        -3196.55322265625,
        1030.70751953125
      ],
      [
        -3070.88916015625,
        -3126.308349609375,
        1053.9906005859375
      ],
      [
        -3662.39306640625,
        -2424.959228515625,
        1174.18994140625
      ],
      [
        -3070.88916015625,
        -3126.308349609375,
        1053.9906005859375
      ],
      [
        -3697.488525390625,
        -2384.901123046875,
        1181.53662109375
      ],
      [
        -3662.39306640625,
        -2424.959228515625,
        1174.18994140625
      ],
      [
        -1529.63916015625,
        -2745.022216796875,
        435.4664001464844
      ],
      [
        -1180.669189453125,
        -2147.973876953125,
        224.8211669921875
      ],
      [
        -1288.892333984375,
        -1953.526123046875,
        -300.0
      ],
      [
        -1942.9771728515625,
        -3113.202392578125,
        638.1046142578125
      ],
      [
        -1655.49462890625,
        -2876.868896484375,
        499.8956298828125
      ],
      [
        -1655.49462890625,
        -2876.868896484375,
        499.8956604003906
      ],
      [
        -1529.63916015625,
        -2745.02197265625,
        435.46630859375
      ],
      [
        -1180.669189453125,
        -2147.973876953125,
        224.82118225097656
      ],
      [
        -1156.463623046875,
        -2051.8349609375,
        202.6451416015625
      ],
      [
        -1643.627197265625,
        707.894287109375,
        0.0
      ],
      [
        -1508.86181640625,
        750.1992797851562,
        -55.32252883911133
      ],
      [
        -1425.26611328125,
        127.9840087890625,
        0.0
      ],
      [
        -1508.86181640625,
        750.1992797851562,
        -55.32252502441406
      ],
      [
        -1825.091796875,
        637.3743286132812,
        76.36678314208984
      ],
      [
        -1643.627197265625,
        707.894287109375,
        0.0
      ],
      [
        -1881.21875,
        615.4686279296875,
        100.0
      ],
      [
        -1825.091796875,
        637.3743286132812,
        76.36678314208984
      ],
      [
        -1127.99072265625,
        -1680.405029296875,
        0.0
      ],
      [
        -1124.295654296875,
        -1528.0806884765625,
        -85.06402587890625
      ],
      [
        -1111.164794921875,
        -2030.1519775390625,
        120.3877182006836
      ],
      [
        -1127.99072265625,
        -1680.405029296875,
        0.0
      ],
      [
        -1124.295654296875,
        -1528.0806884765625,
        -85.06402587890625
      ],
      [
        -1067.126220703125,
        -1434.1708984375,
        -300.0
      ],
      [
        -2380.0,
        670.0,
        -268.82769775390625
      ],
      [
        -2400.0,
        670.0,
        -279.1705322265625
      ],
      [
        -2380.0,
        670.0,
        -268.82769775390625
      ],
      [
        -2440.2783203125,
        670.0,
        -300.0
      ],
      [
        -2440.0,
        670.0,
        -299.85601806640625
      ],
      [
        -2400.0,
        677.0487060546875,
        -300.0
      ],
      [
        -2400.0,
        670.0,
        -279.1705322265625
      ],
      [
        -1425.26611328125,
        127.98397827148438,
        0.0
      ],
      [
        -1420.4962158203125,
        86.82951354980469,
        3.9378738403320312
      ],
      [
        -2357.86669921875,
        611.0,
        -83.03109741210938
      ],
      [
        -2380.0,
        612.868896484375,
        -100.0
      ],
      [
        -2620.0,
        516.72509765625,
        60.0
      ],
      [
        -2380.0,
        558.7251586914062,
        60.0
      ],
      [
        -565.42431640625,
        -1336.6162109375,
        -113.20274353027344
      ],
      [
        -157.67498779296875,
        -1068.1884765625,
        -300.0
      ],
      [
        -1074.1181640625,
        -2033.634033203125,
        169.8988800048828
      ],
      [
        -1121.50390625,
        -1650.1837158203125,
        0.0
      ],
      [
        -1059.9925537109375,
        -1650.0186767578125,
        80.53497314453125
      ],
      [
        -1044.6822509765625,
        -1688.2943115234375,
        111.35455322265625
      ],
      [
        -1044.6822509765625,
        -1688.2943115234375,
        111.35456085205078
      ],
      [
        -1059.9925537109375,
        -1650.0186767578125,
        80.53498077392578
      ],
      [
        -950.483154296875,
        -1590.1065673828125,
        63.19963836669922
      ],
      [
        -1121.50390625,
        -1650.1837158203125,
        0.0
      ],
      [
        -1127.150390625,
        -1645.765380859375,
        -19.344146728515625
      ],
      [
        -826.8541259765625,
        -1461.2427978515625,
        0.0
      ],
      [
        -565.42431640625,
        -1336.6162109375,
        -113.20272827148438
      ],
      [
        -826.8541259765625,
        -1461.2427978515625,
        0.0
      ],
      [
        -1870.0,
        1381.422607421875,
        -10.0
      ],
      [
        -1988.8006591796875,
        1696.926513671875,
        -10.0
      ],
      [
        -2178.24560546875,
        2200.042724609375,
        -10.0
      ],
      [
        -2215.506103515625,
        2298.9970703125,
        -10.0
      ],
      [
        -2215.506103515625,
        2298.9970703125,
        -10.0
      ],
      [
        -2310.01953125,
        2550.0,
        -10.0
      ],
      [
        -1988.80078125,
        1696.926513671875,
        -10.0
      ],
      [
        -2178.24560546875,
        2200.042724609375,
        -10.0
      ],
      [
        -2723.333251953125,
        2573.333251953125,
        -10.0
      ],
      [
        -1565.2630615234375,
        2670.0,
        -300.0
      ],
      [
        -2318.8056640625,
        2573.333251953125,
        -10.000000953674316
      ],
      [
        -1849.3822021484375,
        1326.6666259765625,
        -10.0
      ],
      [
        -1846.306884765625,
        1326.306884765625,
        -11.079254150390625
      ],
      [
        -2723.333251953125,
        1326.6666259765625,
        -10.000000953674316
      ],
      [
        -1807.8961181640625,
        2057.896240234375,
        -126.31155395507812
      ],
      [
        -1846.306884765625,
        1326.306884765625,
        -11.07925033569336
      ],
      [
        -1445.5028076171875,
        2015.5028076171875,
        -253.49160766601562
      ],
      [
        -1807.8961181640625,
        2057.896240234375,
        -126.31155395507812
      ],
      [
        -1430.0,
        2310.7763671875,
        -300.0
      ],
      [
        -1445.5028076171875,
        2015.5028076171875,
        -253.49160766601562
      ],
      [
        -2262.608642578125,
        670.0,
        -10.0
      ],
      [
        -2380.0,
        670.0,
        -10.0
      ],
      [
        -2400.0,
        670.0,
        -10.0
      ],
      [
        -2380.0,
        670.0,
        -10.0
      ],
      [
        -2620.0,
        670.0,
        -10.0
      ],
      [
        -2600.0,
        670.0,
        -10.000000953674316
      ],
      [
        -2560.0,
        670.0,
        -10.0
      ],
      [
        -2520.0,
        670.0,
        -10.000000953674316
      ],
      [
        -2480.0,
        670.0,
        -10.0
      ],
      [
        -2440.0,
        670.0,
        -10.0
      ],
      [
        -2380.0,
        670.0,
        -10.0
      ],
      [
        -2380.0,
        582.4130249023438,
        -10.0
      ],
      [
        -2262.608642578125,
        660.0,
        -10.0
      ],
      [
        -2262.608642578125,
        670.0,
        -10.0
      ],
      [
        -2262.608642578125,
        611.0,
        -10.0
      ],
      [
        -2262.608642578125,
        621.0,
        -10.0
      ],
      [
        -2262.608642578125,
        621.0,
        -10.0
      ],
      [
        -2380.0,
        621.0,
        -10.0
      ],
      [
        -2440.0,
        680.0,
        -10.0
      ],
      [
        -2400.0,
        680.0,
        -10.000000953674316
      ],
      [
        -2520.0,
        680.0,
        -10.0
      ],
      [
        -2480.0,
        680.0,
        -10.000000953674316
      ],
      [
        -2600.0,
        680.0,
        -10.0
      ],
      [
        -2560.0,
        680.0,
        -10.000000953674316
      ],
      [
        -2480.0,
        680.0,
        -10.0
      ],
      [
        -2480.0,
        670.0,
        -10.000000953674316
      ],
      [
        -2560.0,
        680.0,
        -10.0
      ],
      [
        -2560.0,
        670.0,
        -10.000000953674316
      ],
      [
        -2400.0,
        680.0,
        -10.0
      ],
      [
        -2400.0,
        670.0,
        -10.0
      ],
      [
        -2360.0,
        680.0,
        -36.111114501953125
      ],
      [
        -2330.0,
        680.0,
        -36.11111068725586
      ],
      [
        -2330.0,
        670.0,
        -10.0
      ],
      [
        -2330.0,
        680.0,
        -10.0
      ],
      [
        -2330.0,
        680.0,
        -36.111114501953125
      ],
      [
        -2360.0,
        747.1428833007812,
        -10.0
      ],
      [
        -2330.0,
        747.1428833007812,
        -10.0
      ],
      [
        -2330.0,
        747.1428833007812,
        -10.0
      ],
      [
        -1817.047119140625,
        3338.672607421875,
        -300.0
      ],
      [
        -2700.0,
        2066.532470703125,
        200.0
      ],
      [
        -2700.0,
        2550.0,
        133.16798400878906
      ],
      [
        -2700.0,
        1330.0,
        200.0
      ],
      [
        -2700.0,
        1330.0,
        0.0
      ],
      [
        -2720.0,
        2570.0,
        137.74559020996094
      ],
      [
        -2700.0,
        2570.0,
        0.0
      ],
      [
        -2700.0,
        2570.0,
        130.4032745361328
      ],
      [
        -2707.393310546875,
        1337.393310546875,
        303.50665283203125
      ],
      [
        -2712.474609375,
        1337.5252685546875,
        305.3538818359375
      ],
      [
        -2707.33984375,
        1342.6600341796875,
        302.75897216796875
      ],
      [
        -2712.522705078125,
        1342.5228271484375,
        304.6806640625
      ],
      [
        -2707.393310546875,
        1337.393310546875,
        303.5066223144531
      ],
      [
        -2707.33984375,
        1342.6600341796875,
        302.75897216796875
      ],
      [
        -2700.0,
        2570.0,
        0.0
      ],
      [
        -2700.0,
        2573.333251953125,
        -10.0
      ],
      [
        -2700.0,
        1330.0,
        0.0
      ],
      [
        -2700.0,
        1326.6666259765625,
        -10.000000953674316
      ],
      [
        -1877.876708984375,
        1330.0,
        0.0
      ],
      [
        -1885.407470703125,
        1350.0,
        0.0
      ],
      [
        -1870.0,
        1350.0,
        -5.656304359436035
      ],
      [
        -2700.0,
        1350.0,
        59.999847412109375
      ],
      [
        -1885.407470703125,
        1350.0,
        0.0
      ],
      [
        -2048.84326171875,
        1350.0,
        59.999847412109375
      ],
      [
        -2212.692626953125,
        1568.1181640625,
        90.0
      ],
      [
        -2215.49072265625,
        1575.549072265625,
        90.0
      ],
      [
        -2215.49072265625,
        1575.549072265625,
        90.0
      ],
      [
        -2229.065673828125,
        1611.600341796875,
        90.0
      ],
      [
        -2229.065673828125,
        1611.600341796875,
        90.0
      ],
      [
        -2250.62646484375,
        1668.8604736328125,
        90.0
      ],
      [
        -2250.62646484375,
        1668.8603515625,
        90.0
      ],
      [
        -2462.66943359375,
        2231.99169921875,
        90.0
      ],
      [
        -2337.2587890625,
        2550.0,
        0.0
      ],
      [
        -2310.01953125,
        2550.0,
        -10.0
      ],
      [
        -2337.2587890625,
        2550.0,
        0.0
      ],
      [
        -2700.0,
        2550.0,
        90.0
      ],
      [
        -2582.4130859375,
        2550.0,
        90.0
      ],
      [
        -2344.789794921875,
        2570.0,
        0.0
      ],
      [
        -2344.789794921875,
        2570.0,
        0.0
      ],
      [
        -2589.944091796875,
        2570.0,
        90.0
      ],
      [
        -2700.0,
        2570.0,
        90.0
      ],
      [
        -2072.317138671875,
        1645.4378662109375,
        27.777637481689453
      ],
      [
        -2154.448486328125,
        1560.0577392578125,
        69.73190307617188
      ],
      [
        -2009.4462890625,
        1751.7552490234375,
        -10.0
      ],
      [
        -2072.317138671875,
        1645.4378662109375,
        27.777626037597656
      ],
      [
        -2560.0,
        1440.0,
        90.0
      ],
      [
        -2560.0,
        1480.0,
        90.0
      ],
      [
        -2560.0,
        1480.0,
        90.0
      ],
      [
        -2600.0,
        1480.0,
        90.0
      ],
      [
        -2700.0,
        2550.0,
        133.16798400878906
      ],
      [
        -2332.388916015625,
        1886.0,
        90.0
      ],
      [
        -2410.0,
        1886.0,
        118.49224853515625
      ],
      [
        -2274.0,
        1600.721435546875,
        107.99999237060547
      ],
      [
        -2277.493896484375,
        1610.0,
        107.99998474121094
      ],
      [
        -2274.0,
        1600.721435546875,
        107.99999237060547
      ],
      [
        -2262.43212890625,
        1570.0,
        108.00000762939453
      ],
      [
        -2325.0,
        1701.0,
        107.99983215332031
      ],
      [
        -2325.0,
        1701.0,
        112.86090850830078
      ],
      [
        -2325.0,
        1731.0,
        108.71383666992188
      ],
      [
        -2325.0,
        1731.0,
        107.99978637695312
      ],
      [
        -2277.493896484375,
        1610.0,
        107.99998474121094
      ],
      [
        -2282.941650390625,
        1610.0,
        109.99999237060547
      ],
      [
        -2246.0,
        1605.0,
        97.12931823730469
      ],
      [
        -2246.0,
        1575.0,
        101.2763442993164
      ],
      [
        -2279.37646484375,
        1615.0,
        107.99998474121094
      ],
      [
        -2274.0,
        1615.0,
        106.02619934082031
      ],
      [
        -2274.0,
        1610.0,
        106.71736145019531
      ],
      [
        -2274.0,
        1605.6864013671875,
        107.31364440917969
      ],
      [
        -2274.0,
        1615.0,
        106.02619934082031
      ],
      [
        -2274.0,
        1610.0,
        106.71736907958984
      ],
      [
        -2247.0,
        1575.0,
        101.6434326171875
      ],
      [
        -2246.0,
        1575.0,
        90.0
      ],
      [
        -2246.0,
        1575.0,
        101.27629852294922
      ],
      [
        -2247.0,
        1610.0,
        96.80522918701172
      ],
      [
        -2246.0,
        1610.0,
        89.99998474121094
      ],
      [
        -2246.0,
        1610.0,
        96.4381103515625
      ],
      [
        -2245.0,
        1575.0,
        100.90918731689453
      ],
      [
        -2245.0,
        1570.0,
        101.60039520263672
      ],
      [
        -2245.0,
        1610.0,
        96.07098388671875
      ],
      [
        -2245.0,
        1605.0,
        96.76216125488281
      ],
      [
        -2245.0,
        1575.0,
        100.90916442871094
      ],
      [
        -2245.0,
        1610.0,
        96.07098388671875
      ],
      [
        -2422.6640625,
        1330.0,
        200.0
      ],
      [
        -1877.876708984375,
        1330.0,
        0.0
      ],
      [
        -2430.19482421875,
        1350.0,
        200.0
      ],
      [
        -2600.0,
        668.3333129882812,
        2.0
      ],
      [
        -2620.0,
        668.3333129882812,
        2.0
      ],
      [
        -2560.0,
        668.3333129882812,
        2.0
      ],
      [
        -2520.0,
        668.3333129882812,
        2.0
      ],
      [
        -2440.0,
        668.3333129882812,
        2.0
      ],
      [
        -2480.0,
        668.3333129882812,
        2.0
      ],
      [
        -2480.0,
        679.0,
        2.0
      ],
      [
        -2520.0,
        679.0,
        2.0
      ],
      [
        -2400.0,
        679.0,
        2.0
      ],
      [
        -2440.0,
        679.0,
        2.0
      ],
      [
        -2560.0,
        679.0,
        2.0
      ],
      [
        -2600.0,
        679.0,
        2.0
      ],
      [
        -2480.0,
        679.0,
        2.0
      ],
      [
        -2480.0,
        668.3333129882812,
        2.0
      ],
      [
        -2560.0,
        679.0,
        2.0
      ],
      [
        -2560.0,
        668.3333129882812,
        2.0
      ],
      [
        -2400.0,
        679.0,
        2.0
      ],
      [
        -2400.0,
        668.3333129882812,
        2.0
      ],
      [
        -2191.428466796875,
        672.4571533203125,
        2.0
      ],
      [
        -2215.0,
        680.0,
        2.0
      ],
      [
        -2215.0,
        625.0,
        2.0
      ],
      [
        -2190.514404296875,
        625.0,
        2.0
      ],
      [
        -2190.514404296875,
        618.1142578125,
        2.0
      ],
      [
        -2190.514404296875,
        625.0,
        2.0
      ],
      [
        -2190.514404296875,
        666.0,
        2.0
      ],
      [
        -2190.514404296875,
        671.8857421875,
        2.0
      ],
      [
        -2190.514404296875,
        671.8857421875,
        2.0
      ],
      [
        -2191.428466796875,
        672.4571533203125,
        2.0
      ],
      [
        -2600.0,
        624.4326171875,
        54.68083572387695
      ],
      [
        -2620.0,
        624.4326171875,
        54.68083572387695
      ],
      [
        -2560.0,
        624.4326171875,
        54.68083572387695
      ],
      [
        -2520.0,
        624.4326171875,
        54.68083572387695
      ],
      [
        -2440.0,
        624.4326171875,
        54.68083572387695
      ],
      [
        -2480.0,
        624.4326171875,
        54.68083572387695
      ],
      [
        -2480.0,
        624.4326171875,
        54.68083572387695
      ],
      [
        -2480.0,
        628.3333740234375,
        60.0
      ],
      [
        -2560.0,
        624.4326171875,
        54.68083572387695
      ],
      [
        -2560.0,
        628.3333740234375,
        60.0
      ],
      [
        -2400.0,
        624.4326171875,
        54.68083572387695
      ],
      [
        -2400.0,
        628.3333740234375,
        60.0
      ],
      [
        -2212.837158203125,
        625.8551635742188,
        56.6206169128418
      ],
      [
        -2215.0,
        628.3333740234375,
        60.0
      ],
      [
        -2600.0,
        625.0,
        53.999977111816406
      ],
      [
        -2620.0,
        625.0,
        53.999977111816406
      ],
      [
        -2560.0,
        625.0,
        53.999977111816406
      ],
      [
        -2520.0,
        625.0,
        53.999977111816406
      ],
      [
        -2440.0,
        625.0,
        53.999977111816406
      ],
      [
        -2480.0,
        625.0,
        53.999977111816406
      ],
      [
        -2210.816162109375,
        625.0,
        53.46286392211914
      ],
      [
        -2199.0,
        625.0,
        35.0
      ],
      [
        -2196.4287109375,
        619.4285888671875,
        25.0
      ],
      [
        -2196.4287109375,
        625.0,
        25.0
      ],
      [
        -2480.0,
        625.0,
        53.999977111816406
      ],
      [
        -2480.0,
        625.0,
        55.454532623291016
      ],
      [
        -2560.0,
        625.0,
        53.999977111816406
      ],
      [
        -2560.0,
        625.0,
        55.454532623291016
      ],
      [
        -2400.0,
        625.0,
        53.999977111816406
      ],
      [
        -2400.0,
        625.0,
        55.454532623291016
      ],
      [
        -2211.07568359375,
        625.1097412109375,
        53.868194580078125
      ],
      [
        -2199.0,
        640.833251953125,
        35.0
      ],
      [
        -2215.0,
        640.833251953125,
        35.0
      ],
      [
        -2199.0,
        640.833251953125,
        35.0
      ],
      [
        -2191.234375,
        666.0,
        4.7999420166015625
      ],
      [
        -2190.514404296875,
        668.3333129882812,
        2.0
      ],
      [
        -2375.0,
        669.9378051757812,
        50.0
      ],
      [
        -2340.0,
        680.0,
        60.0
      ],
      [
        -2375.0,
        680.0,
        50.0
      ],
      [
        -2380.0,
        621.0,
        0.0
      ],
      [
        -2380.0,
        621.0,
        -10.0
      ],
      [
        -2400.0,
        680.0,
        -5.0
      ],
      [
        -2400.0,
        670.0,
        -5.0
      ],
      [
        -2480.0,
        680.0,
        -5.0
      ],
      [
        -2480.0,
        670.0,
        -5.0
      ],
      [
        -2560.0,
        680.0,
        -5.0
      ],
      [
        -2560.0,
        670.0,
        -5.0
      ],
      [
        -2330.0,
        680.0,
        -5.0
      ],
      [
        -2330.0,
        680.0,
        -10.0
      ],
      [
        -2320.0,
        785.0,
        0.0
      ],
      [
        -2320.0,
        795.0,
        0.0
      ],
      [
        -2320.0,
        735.0,
        0.0
      ],
      [
        -2374.14208984375,
        730.6066284179688,
        50.0
      ],
      [
        -2360.0,
        735.0,
        50.0
      ],
      [
        -2350.0,
        731.8934326171875,
        60.0
      ],
      [
        -2360.0,
        735.0,
        50.0
      ],
      [
        -2355.0,
        733.4467163085938,
        50.0
      ],
      [
        -2345.85791015625,
        730.6066284179688,
        50.0
      ],
      [
        -2340.0,
        720.0,
        50.0
      ],
      [
        -2345.85791015625,
        730.6066284179688,
        50.0
      ],
      [
        -2379.0,
        721.8106689453125,
        47.5
      ],
      [
        -2379.0,
        721.8106689453125,
        40.0
      ],
      [
        -3662.578857421875,
        6233.91845703125,
        -22.699951171875
      ],
      [
        -2033.783935546875,
        -3822.73583984375,
        1544.3731689453125
      ],
      [
        -2033.0440673828125,
        -3821.2294921875,
        1499.2650146484375
      ],
      [
        7399.73876953125,
        -2162.2490234375,
        976.300048828125
      ],
      [
        7672.87158203125,
        -789.118408203125,
        -22.699951171875
      ],
      [
        7671.36669921875,
        -796.68505859375,
        6.103515625e-05
      ],
      [
        4526.4208984375,
        -1556.87548828125,
        543.49267578125
      ],
      [
        -1145.6080322265625,
        -2059.143798828125,
        251.769287109375
      ],
      [
        -158.70803833007812,
        -3106.798095703125,
        670.1329345703125
      ],
      [
        334.5896301269531,
        -3672.376220703125,
        892.7235107421875
      ],
      [
        -158.70806884765625,
        -3106.79833984375,
        670.1329956054688
      ],
      [
        -1527.4627685546875,
        -2745.952392578125,
        440.9891357421875
      ],
      [
        -1174.739013671875,
        -2184.3720703125,
        289.6177673339844
      ],
      [
        -1174.739013671875,
        -2184.3720703125,
        289.6177978515625
      ],
      [
        -1145.6080322265625,
        -2059.143798828125,
        251.769287109375
      ],
      [
        -1549.2021484375,
        -2765.516357421875,
        445.481201171875
      ],
      [
        -1527.4627685546875,
        -2745.9521484375,
        440.989013671875
      ],
      [
        -794.8798828125,
        -1446.0003662109375,
        -13.845283508300781
      ],
      [
        -504.59906005859375,
        -1467.1614990234375,
        114.45516204833984
      ],
      [
        -1018.4613037109375,
        -1753.8465576171875,
        164.13726806640625
      ],
      [
        -681.8505859375,
        -1625.7083740234375,
        150.7703399658203
      ],
      [
        -1009.0797729492188,
        -2039.7471923828125,
        256.8197326660156
      ],
      [
        -1018.4613037109375,
        -1753.8466796875,
        164.1372833251953
      ],
      [
        -504.59906005859375,
        -1467.1614990234375,
        114.45515441894531
      ],
      [
        -681.8506469726562,
        -1625.7083740234375,
        150.77035522460938
      ],
      [
        -1143.6485595703125,
        -2061.22412109375,
        252.5999755859375
      ],
      [
        -236.0840606689453,
        -3010.201904296875,
        790.0325927734375
      ],
      [
        353.0361328125,
        -3680.16650390625,
        1163.4200439453125
      ],
      [
        -236.08407592773438,
        -3010.2021484375,
        790.0326538085938
      ],
      [
        -1492.434326171875,
        -2760.922119140625,
        529.8773803710938
      ],
      [
        -1172.828125,
        -2196.1005859375,
        310.4969177246094
      ],
      [
        -1939.5809326171875,
        -3110.410400390625,
        636.4718627929688
      ],
      [
        -1648.24072265625,
        -2909.402099609375,
        579.1571044921875
      ],
      [
        -1648.24072265625,
        -2909.402099609375,
        579.1570434570312
      ],
      [
        -1492.434326171875,
        -2760.921875,
        529.8772583007812
      ],
      [
        -1172.828125,
        -2196.100341796875,
        310.4968566894531
      ],
      [
        -1146.2474365234375,
        -2061.892333984375,
        252.59999084472656
      ],
      [
        -1007.595458984375,
        -2039.88671875,
        258.803466796875
      ],
      [
        -1009.5068969726562,
        -2026.73095703125,
        252.60015869140625
      ],
      [
        1019.587158203125,
        -1695.0367431640625,
        431.56463623046875
      ],
      [
        -1088.6651611328125,
        -2097.481689453125,
        509.45013427734375
      ],
      [
        -317.6634521484375,
        -2908.3583984375,
        916.4456787109375
      ],
      [
        362.54669189453125,
        -3684.182861328125,
        1302.9847412109375
      ],
      [
        -317.66339111328125,
        -2908.358642578125,
        916.4456176757812
      ],
      [
        -2101.2802734375,
        -3399.51513671875,
        1050.8297119140625
      ],
      [
        -2144.1455078125,
        -3408.1083984375,
        1052.5999755859375
      ],
      [
        -1378.6275634765625,
        -2809.558349609375,
        818.6738891601562
      ],
      [
        -1143.2017822265625,
        -2377.942626953125,
        634.2150268554688
      ],
      [
        -2099.20068359375,
        -3398.540283203125,
        1050.490234375
      ],
      [
        -1617.5257568359375,
        -3047.155029296875,
        914.7691650390625
      ],
      [
        -2099.20068359375,
        -3398.540283203125,
        1050.490234375
      ],
      [
        -2101.2802734375,
        -3399.51513671875,
        1050.8297119140625
      ],
      [
        -1617.5257568359375,
        -3047.155029296875,
        914.7692260742188
      ],
      [
        -1378.6275634765625,
        -2809.55810546875,
        818.673828125
      ],
      [
        -1143.2017822265625,
        -2377.942626953125,
        634.215087890625
      ],
      [
        -1088.6651611328125,
        -2097.481689453125,
        509.4501037597656
      ],
      [
        544.5404052734375,
        -1746.0208740234375,
        431.07000732421875
      ],
      [
        -52.859100341796875,
        -1691.1807861328125,
        376.37713623046875
      ],
      [
        -436.7973327636719,
        -1689.80029296875,
        356.619873046875
      ],
      [
        -778.3905029296875,
        -2110.8046875,
        530.965576171875
      ],
      [
        -614.9921264648438,
        -1565.9052734375,
        137.07241821289062
      ],
      [
        -1012.9479370117188,
        -1921.8660888671875,
        218.60536193847656
      ],
      [
        544.5404663085938,
        -1746.0208740234375,
        431.07000732421875
      ],
      [
        1019.5870971679688,
        -1695.0367431640625,
        431.56463623046875
      ],
      [
        -411.225341796875,
        -1658.283447265625,
        343.5681457519531
      ],
      [
        -411.225341796875,
        -1658.283447265625,
        343.56817626953125
      ],
      [
        2400.0,
        -1844.385986328125,
        749.0462646484375
      ],
      [
        4526.4208984375,
        -1556.87548828125,
        543.49267578125
      ],
      [
        85.42315673828125,
        -3334.0634765625,
        1814.080322265625
      ],
      [
        -560.6012573242188,
        -2605.0751953125,
        1292.895263671875
      ],
      [
        -1025.829345703125,
        -2139.787109375,
        793.7977294921875
      ],
      [
        -560.601318359375,
        -2605.074951171875,
        1292.895263671875
      ],
      [
        -869.4028930664062,
        -2286.437255859375,
        1065.087646484375
      ],
      [
        -4123.98779296875,
        -2759.122802734375,
        1403.0306396484375
      ],
      [
        -4131.109375,
        -2740.787109375,
        1389.9215087890625
      ],
      [
        -1100.671875,
        -2928.344970703125,
        1524.014892578125
      ],
      [
        -1067.298095703125,
        -2843.8271484375,
        1463.5894775390625
      ],
      [
        -1067.298095703125,
        -2843.8271484375,
        1463.5894775390625
      ],
      [
        -1025.829345703125,
        -2139.787353515625,
        793.7976684570312
      ],
      [
        -1001.381103515625,
        -2304.28173828125,
        1077.845458984375
      ],
      [
        -1100.671875,
        -2928.344970703125,
        1524.014892578125
      ],
      [
        -1247.748291015625,
        -3108.19873046875,
        1652.5999755859375
      ],
      [
        -3557.677978515625,
        -2549.120361328125,
        1152.9107666015625
      ],
      [
        -3528.30859375,
        -2586.1181640625,
        1220.0
      ],
      [
        -2988.559814453125,
        -3223.927001953125,
        1037.2603759765625
      ],
      [
        191.95574951171875,
        -2234.215087890625,
        1027.7518310546875
      ],
      [
        360.59326171875,
        -2000.717041015625,
        742.3652954101562
      ],
      [
        1109.864501953125,
        -2018.8233642578125,
        873.759033203125
      ],
      [
        -166.50149536132812,
        -2318.328857421875,
        1087.8883056640625
      ],
      [
        -193.138916015625,
        -2403.4306640625,
        1148.731201171875
      ],
      [
        -609.42333984375,
        -1902.55712890625,
        444.7264404296875
      ],
      [
        -476.1239929199219,
        -1980.4971923828125,
        595.6363525390625
      ],
      [
        -164.9033203125,
        -2162.4677734375,
        947.973388671875
      ],
      [
        -136.1424102783203,
        -2221.3369140625,
        1018.5446166992188
      ],
      [
        -136.14242553710938,
        -2221.3369140625,
        1018.5445556640625
      ],
      [
        -164.90333557128906,
        -2162.4677734375,
        947.973388671875
      ],
      [
        360.59344482421875,
        -2000.7166748046875,
        742.3648681640625
      ],
      [
        191.9557342529297,
        -2234.215087890625,
        1027.7518310546875
      ],
      [
        1721.03564453125,
        -1875.4091796875,
        771.22607421875
      ],
      [
        2400.0,
        -1844.385986328125,
        749.0462646484375
      ],
      [
        1721.03564453125,
        -1875.4091796875,
        771.22607421875
      ],
      [
        -476.1240234375,
        -1980.4971923828125,
        595.6363525390625
      ],
      [
        -580.3717041015625,
        -1866.7518310546875,
        429.8988037109375
      ],
      [
        -374.75189208984375,
        -1732.9390869140625,
        433.0637512207031
      ],
      [
        -52.859130859375,
        -1691.1807861328125,
        376.37713623046875
      ],
      [
        -374.75189208984375,
        -1732.9390869140625,
        433.06378173828125
      ],
      [
        -436.7973327636719,
        -1689.80029296875,
        356.619873046875
      ],
      [
        -987.384765625,
        -2165.6708984375,
        967.7686157226562
      ],
      [
        -963.984130859375,
        -2188.843505859375,
        995.3135986328125
      ],
      [
        -987.384765625,
        -2165.6708984375,
        967.7688598632812
      ],
      [
        -987.1666259765625,
        -2187.933349609375,
        994.6629028320312
      ],
      [
        -3652.813720703125,
        -2436.3173828125,
        1172.2432861328125
      ],
      [
        -3597.956298828125,
        -2503.115234375,
        1220.0
      ],
      [
        -984.6701049804688,
        -2167.49853515625,
        980.05322265625
      ],
      [
        -984.6701049804688,
        -2167.49853515625,
        980.05322265625
      ],
      [
        6992.10546875,
        -1390.916015625,
        590.90966796875
      ],
      [
        1109.865478515625,
        -2018.8232421875,
        873.7589111328125
      ],
      [
        7484.2607421875,
        -1737.3270263671875,
        976.300048828125
      ],
      [
        7602.89599609375,
        -1140.9091796875,
        246.10055541992188
      ],
      [
        7569.6552734375,
        -1308.022216796875,
        526.8804931640625
      ],
      [
        -233.89080810546875,
        -2962.61669921875,
        1774.980712890625
      ],
      [
        -556.1375122070312,
        -2604.275390625,
        1411.1329345703125
      ],
      [
        -596.04345703125,
        -2560.829345703125,
        1347.8155517578125
      ],
      [
        -1027.7886962890625,
        -2520.433837890625,
        1232.3817138671875
      ],
      [
        -1020.4502563476562,
        -2691.334228515625,
        1460.001953125
      ],
      [
        -1033.012451171875,
        -2899.037353515625,
        1656.375
      ],
      [
        -713.9907836914062,
        -2446.799560546875,
        1179.737548828125
      ],
      [
        -596.0433349609375,
        -2560.8291015625,
        1347.8153076171875
      ],
      [
        -166.50149536132812,
        -2318.328857421875,
        1087.8883056640625
      ],
      [
        -1001.381103515625,
        -2304.281982421875,
        1077.8455810546875
      ],
      [
        -998.296142578125,
        -2325.03857421875,
        1113.6878662109375
      ],
      [
        -869.4028930664062,
        -2286.437255859375,
        1065.087646484375
      ],
      [
        -602.860107421875,
        -2552.319091796875,
        1358.37841796875
      ],
      [
        -841.74365234375,
        -2312.367919921875,
        1113.0570068359375
      ],
      [
        -602.8601684570312,
        -2552.3193359375,
        1358.3785400390625
      ],
      [
        -987.4636840820312,
        -2397.92236328125,
        1239.5428466796875
      ],
      [
        -1014.552978515625,
        -2843.658935546875,
        1660.47705078125
      ],
      [
        -274.495849609375,
        -2915.38232421875,
        1770.0086669921875
      ],
      [
        -620.4629516601562,
        -2530.343994140625,
        1385.6552734375
      ],
      [
        -620.462890625,
        -2530.34375,
        1385.6551513671875
      ],
      [
        -773.8843994140625,
        -2375.986083984375,
        1230.7449951171875
      ],
      [
        -4125.63623046875,
        -2756.2802734375,
        1402.974609375
      ],
      [
        -4128.15283203125,
        -2748.399658203125,
        1395.3641357421875
      ],
      [
        6992.103515625,
        -1390.916015625,
        590.90966796875
      ],
      [
        3366.189697265625,
        -1334.87353515625,
        384.7739562988281
      ],
      [
        7666.32373046875,
        -822.0380859375,
        18.126018524169922
      ],
      [
        -973.9005126953125,
        -2174.74951171875,
        1028.7882080078125
      ],
      [
        -973.9005126953125,
        -2174.74951171875,
        1028.7882080078125
      ],
      [
        7486.08837890625,
        -1728.1380615234375,
        976.300048828125
      ],
      [
        7569.6552734375,
        -1308.022216796875,
        526.8804931640625
      ],
      [
        7560.24072265625,
        -1355.351806640625,
        606.4027709960938
      ],
      [
        2962.535400390625,
        -1257.6370849609375,
        329.5543518066406
      ],
      [
        7669.3662109375,
        -806.7422485351562,
        7.19039249420166
      ],
      [
        7562.35693359375,
        -1344.71240234375,
        595.8457641601562
      ],
      [
        7561.4580078125,
        -1349.2322998046875,
        600.3306274414062
      ],
      [
        7560.7802734375,
        -1352.6395263671875,
        601.8455810546875
      ],
      [
        2455.532470703125,
        -1160.625732421875,
        260.1967468261719
      ],
      [
        2621.07421875,
        -1158.5028076171875,
        267.47998046875
      ],
      [
        7561.4580078125,
        -1349.2322998046875,
        600.33056640625
      ],
      [
        7561.59912109375,
        -1348.522705078125,
        600.01513671875
      ],
      [
        7493.19580078125,
        -1692.408203125,
        976.300048828125
      ],
      [
        -903.2229614257812,
        -2222.334716796875,
        1348.62158203125
      ],
      [
        -909.1630249023438,
        -2527.489013671875,
        1683.8970947265625
      ],
      [
        -575.9976196289062,
        -2564.65576171875,
        1733.090087890625
      ],
      [
        -725.1876220703125,
        -2399.605712890625,
        1547.93359375
      ],
      [
        -903.2229614257812,
        -2222.334716796875,
        1348.62158203125
      ],
      [
        -725.1875610351562,
        -2399.605712890625,
        1547.9334716796875
      ],
      [
        -3749.496337890625,
        -2237.32958984375,
        1293.859130859375
      ],
      [
        -3766.849609375,
        -2126.165771484375,
        1171.234130859375
      ],
      [
        -3725.157958984375,
        -2329.201904296875,
        1299.860595703125
      ],
      [
        -3714.01416015625,
        -2323.6279296875,
        1179.1334228515625
      ],
      [
        -3697.798095703125,
        -2384.52392578125,
        1182.3121337890625
      ],
      [
        -3697.73974609375,
        -2384.451171875,
        1181.5667724609375
      ],
      [
        -3697.797607421875,
        -2384.524658203125,
        1182.310546875
      ],
      [
        -3702.450439453125,
        -2378.30322265625,
        1210.55859375
      ],
      [
        -3702.450439453125,
        -2378.30322265625,
        1210.55859375
      ],
      [
        -3703.801513671875,
        -2376.973876953125,
        1220.0
      ],
      [
        7606.6337890625,
        -1122.1182861328125,
        976.300048828125
      ],
      [
        -4022.8212890625,
        -1204.943603515625,
        1224.7767333984375
      ],
      [
        -4021.5146484375,
        -1174.40478515625,
        1133.1591796875
      ],
      [
        200.0,
        7450.0,
        680.7955932617188
      ],
      [
        3108.39404296875,
        6871.484375,
        547.1160278320312
      ],
      [
        -2708.39404296875,
        6871.484375,
        470.3934631347656
      ],
      [
        200.0,
        7450.0,
        680.7955932617188
      ],
      [
        -2282.5439453125,
        6956.19140625,
        297.51165771484375
      ],
      [
        -2525.290771484375,
        6907.90625,
        150.0
      ],
      [
        3108.39404296875,
        6871.484375,
        547.1160278320312
      ],
      [
        5574.01171875,
        5224.01171875,
        89.70620727539062
      ],
      [
        235.99966430664062,
        5035.24365234375,
        -36.837890625
      ],
      [
        228.268310546875,
        5028.201171875,
        -58.07283020019531
      ],
      [
        427.0267028808594,
        7267.0830078125,
        -58.07278823852539
      ],
      [
        5574.01171875,
        5224.01171875,
        89.7060546875
      ],
      [
        5701.07958984375,
        5033.84130859375,
        34.8285026550293
      ],
      [
        5713.9326171875,
        5014.60546875,
        -22.699951171875
      ],
      [
        259.23272705078125,
        5158.08642578125,
        0.0
      ],
      [
        235.99966430664062,
        5035.24365234375,
        -36.837890625
      ],
      [
        -1857.3211669921875,
        6954.4736328125,
        506.298583984375
      ],
      [
        -1146.6842041015625,
        5724.8427734375,
        150.0
      ],
      [
        -2708.39404296875,
        6871.484375,
        38.732242584228516
      ],
      [
        -2778.40673828125,
        6824.703125,
        -22.699951171875
      ],
      [
        -2708.39404296875,
        6871.484375,
        470.3934631347656
      ],
      [
        -4095.87744140625,
        5944.39794921875,
        176.39259338378906
      ],
      [
        3966.75,
        4947.60009765625,
        -13.693603515625
      ],
      [
        5834.28564453125,
        4834.484375,
        -22.699951171875
      ],
      [
        4141.0390625,
        4144.17333984375,
        -250.32057189941406
      ],
      [
        3966.75,
        4947.60009765625,
        -13.693601608276367
      ],
      [
        3926.693359375,
        3986.625,
        -300.0
      ],
      [
        4141.0390625,
        4144.17333984375,
        -250.32057189941406
      ],
      [
        3108.39404296875,
        6871.484375,
        589.1253662109375
      ],
      [
        4128.34375,
        6189.97607421875,
        976.300048828125
      ],
      [
        6920.2578125,
        3209.21142578125,
        976.300048828125
      ],
      [
        7221.484375,
        2758.39404296875,
        877.620361328125
      ],
      [
        7221.484375,
        2758.39404296875,
        877.620361328125
      ],
      [
        7532.55712890625,
        1194.52685546875,
        -22.699951171875
      ],
      [
        3108.39404296875,
        6871.484375,
        589.1253662109375
      ],
      [
        3052.0458984375,
        6882.69287109375,
        549.7059936523438
      ],
      [
        3973.22314453125,
        4917.7607421875,
        -22.481956481933594
      ],
      [
        3956.6728515625,
        4948.55078125,
        -13.543867111206055
      ],
      [
        3020.6171875,
        6729.98193359375,
        570.58251953125
      ],
      [
        2769.303955078125,
        7185.4150390625,
        710.5693969726562
      ],
      [
        3020.6171875,
        6729.98193359375,
        570.58251953125
      ],
      [
        3108.39404296875,
        6871.484375,
        620.9074096679688
      ],
      [
        2816.62109375,
        6929.521484375,
        560.5269165039062
      ],
      [
        2922.084228515625,
        6908.54345703125,
        625.4669799804688
      ],
      [
        3018.31103515625,
        6889.40283203125,
        624.2333374023438
      ],
      [
        3108.39404296875,
        6871.484375,
        620.9074096679688
      ],
      [
        3163.70068359375,
        6834.52978515625,
        610.119873046875
      ],
      [
        3955.45556640625,
        4948.66552734375,
        -13.525781631469727
      ],
      [
        2925.637451171875,
        6907.8369140625,
        627.6549072265625
      ],
      [
        3108.39404296875,
        6871.484375,
        740.189208984375
      ],
      [
        3968.13720703125,
        6297.0224609375,
        976.300048828125
      ],
      [
        3108.39404296875,
        6871.484375,
        740.1891479492188
      ],
      [
        6403.22509765625,
        4902.06201171875,
        1961.4566650390625
      ],
      [
        5234.20947265625,
        3452.511474609375,
        1461.146240234375
      ],
      [
        7645.78857421875,
        625.27197265625,
        976.300048828125
      ],
      [
        7800.0,
        -150.0,
        616.764892578125
      ],
      [
        2909.445068359375,
        1830.0,
        60.0
      ],
      [
        2913.460693359375,
        1720.0911865234375,
        60.0
      ],
      [
        2913.460693359375,
        1720.091064453125,
        60.0
      ],
      [
        2914.487548828125,
        1691.9886474609375,
        60.0
      ],
      [
        2914.487548828125,
        1691.9886474609375,
        60.0
      ],
      [
        7800.0,
        -150.0,
        60.0
      ],
      [
        7667.38818359375,
        -816.68505859375,
        60.0
      ],
      [
        3963.4296875,
        4013.626953125,
        -291.4855651855469
      ],
      [
        3180.0,
        601.0,
        60.0
      ],
      [
        2951.52099609375,
        669.5238647460938,
        59.60319519042969
      ],
      [
        2951.8466796875,
        669.4459838867188,
        60.0
      ],
      [
        4131.83447265625,
        4186.60400390625,
        -237.82376098632812
      ],
      [
        3285.123046875,
        1852.6285400390625,
        488.7391357421875
      ],
      [
        3249.21630859375,
        2461.31005859375,
        413.9189758300781
      ],
      [
        3662.360107421875,
        2778.274169921875,
        667.953125
      ],
      [
        3691.61572265625,
        2747.6103515625,
        690.344482421875
      ],
      [
        7800.0,
        -150.0,
        616.764892578125
      ],
      [
        7655.517578125,
        -876.36376953125,
        239.03619384765625
      ],
      [
        3006.535888671875,
        655.2515258789062,
        104.24549865722656
      ],
      [
        2977.499755859375,
        661.7500610351562,
        60.0
      ],
      [
        3006.5361328125,
        655.25146484375,
        104.24565887451172
      ],
      [
        3083.61474609375,
        663.7093505859375,
        221.69898986816406
      ],
      [
        3312.43017578125,
        1790.47265625,
        489.9930419921875
      ],
      [
        3285.123046875,
        1852.6285400390625,
        488.7391357421875
      ],
      [
        3312.43017578125,
        1790.47265625,
        489.9930419921875
      ],
      [
        2979.648193359375,
        1690.0,
        140.0
      ],
      [
        2955.164306640625,
        668.6527709960938,
        64.04167175292969
      ],
      [
        2955.16357421875,
        668.6530151367188,
        64.04100036621094
      ],
      [
        2974.532958984375,
        1830.0,
        140.0
      ],
      [
        3228.21484375,
        1830.0,
        451.8016357421875
      ],
      [
        3228.21484375,
        1830.0,
        451.8016357421875
      ],
      [
        3227.146728515625,
        1836.1837158203125,
        450.7663879394531
      ],
      [
        3249.21630859375,
        2461.31005859375,
        413.9189758300781
      ],
      [
        3217.469482421875,
        1892.20361328125,
        441.38787841796875
      ],
      [
        3124.01220703125,
        2356.111572265625,
        347.3514404296875
      ],
      [
        3217.469482421875,
        1892.20361328125,
        441.38787841796875
      ],
      [
        3691.61572265625,
        2747.6103515625,
        690.3444213867188
      ],
      [
        3662.360107421875,
        2778.274169921875,
        667.953125
      ],
      [
        3723.898193359375,
        2824.480712890625,
        706.9375610351562
      ],
      [
        2780.0,
        2158.722900390625,
        60.0
      ],
      [
        2673.99072265625,
        2020.1932373046875,
        60.0
      ],
      [
        2673.99072265625,
        2020.1932373046875,
        60.0
      ],
      [
        2653.8408203125,
        1993.862060546875,
        60.0
      ],
      [
        2653.8408203125,
        1993.862060546875,
        60.0
      ],
      [
        2638.10546875,
        1973.299560546875,
        60.0
      ],
      [
        2638.10546875,
        1973.299560546875,
        60.0
      ],
      [
        2603.02001953125,
        1927.4510498046875,
        60.0
      ],
      [
        2603.02001953125,
        1927.4510498046875,
        60.0
      ],
      [
        2575.8193359375,
        1891.9058837890625,
        60.0
      ],
      [
        2575.8193359375,
        1891.9058837890625,
        60.0
      ],
      [
        2443.03662109375,
        1718.389892578125,
        60.0
      ],
      [
        2156.978515625,
        670.0,
        60.0
      ],
      [
        2026.0242919921875,
        1027.9033203125,
        60.0
      ],
      [
        2032.1978759765625,
        1181.5185546875,
        60.0
      ],
      [
        2443.03662109375,
        1718.389892578125,
        60.0
      ],
      [
        2951.8466796875,
        669.4459838867188,
        60.0
      ],
      [
        3211.686279296875,
        1830.0,
        440.3035583496094
      ],
      [
        3060.96875,
        2303.809326171875,
        313.0718078613281
      ],
      [
        3066.83935546875,
        2308.073974609375,
        316.9542236328125
      ],
      [
        3066.83935546875,
        2308.073974609375,
        316.9542236328125
      ],
      [
        2939.536376953125,
        1830.0,
        140.0
      ],
      [
        3211.685546875,
        1830.0,
        440.3029479980469
      ],
      [
        2780.0,
        2099.70263671875,
        127.25813293457031
      ],
      [
        3916.41162109375,
        2169.21142578125,
        890.8116455078125
      ],
      [
        4137.6171875,
        2092.764404296875,
        991.831298828125
      ],
      [
        3916.41162109375,
        2169.21142578125,
        890.8115234375
      ],
      [
        3991.455322265625,
        2433.339599609375,
        919.8317260742188
      ],
      [
        3991.45556640625,
        2433.33935546875,
        919.8318481445312
      ],
      [
        2012.468017578125,
        690.5862426757812,
        60.0
      ],
      [
        2013.0179443359375,
        704.27001953125,
        60.0
      ],
      [
        2009.5205078125,
        617.2456665039062,
        60.0
      ],
      [
        2012.468017578125,
        690.5862426757812,
        60.0
      ],
      [
        2013.017822265625,
        704.2701416015625,
        60.0
      ],
      [
        5234.20947265625,
        3452.511474609375,
        1461.146240234375
      ],
      [
        3929.203369140625,
        2164.790771484375,
        896.6533813476562
      ],
      [
        1824.1854248046875,
        771.1151733398438,
        60.0
      ],
      [
        1833.362548828125,
        833.6629028320312,
        60.0
      ],
      [
        1793.210205078125,
        560.0,
        60.0
      ],
      [
        1824.1854248046875,
        771.1151733398438,
        60.0
      ],
      [
        1833.362548828125,
        833.6629638671875,
        60.0
      ],
      [
        1849.3411865234375,
        942.567138671875,
        60.0
      ],
      [
        1554.226318359375,
        556.920166015625,
        60.0
      ],
      [
        1557.2431640625,
        560.8624267578125,
        60.0
      ],
      [
        1744.288330078125,
        805.2874145507812,
        60.0
      ],
      [
        1789.9368896484375,
        864.9393310546875,
        60.0
      ],
      [
        1557.2431640625,
        560.8624267578125,
        60.0
      ],
      [
        1744.2884521484375,
        805.287353515625,
        60.0
      ],
      [
        1789.9368896484375,
        864.9393920898438,
        60.0
      ],
      [
        3908.25439453125,
        3971.215576171875,
        -300.0
      ],
      [
        3954.2470703125,
        4948.779296875,
        -13.507823944091797
      ],
      [
        2922.08447265625,
        6908.54345703125,
        625.4671630859375
      ],
      [
        816.3798217773438,
        7327.39453125,
        652.4647216796875
      ],
      [
        -2708.39404296875,
        6871.484375,
        884.7994384765625
      ],
      [
        -2265.23388671875,
        6959.63427734375,
        976.300048828125
      ],
      [
        -292.60101318359375,
        5125.58740234375,
        226.8505096435547
      ],
      [
        -419.21197509765625,
        5100.55615234375,
        150.0
      ],
      [
        -2708.39404296875,
        6871.484375,
        884.7994384765625
      ],
      [
        -4465.9453125,
        5697.12646484375,
        346.4318542480469
      ],
      [
        -830.5,
        5131.4599609375,
        237.0
      ],
      [
        -830.5,
        5133.12646484375,
        242.0
      ],
      [
        -832.5,
        5133.1357421875,
        242.0
      ],
      [
        -834.9564819335938,
        5133.14697265625,
        242.0
      ],
      [
        1489.045166015625,
        532.9466552734375,
        60.0
      ],
      [
        1181.7359619140625,
        621.3192138671875,
        60.0
      ],
      [
        1181.735595703125,
        621.3192749023438,
        60.0
      ],
      [
        -115.25515747070312,
        994.2936401367188,
        60.0
      ],
      [
        -601.5899658203125,
        1369.506103515625,
        60.0
      ],
      [
        -2657.889892578125,
        3369.26904296875,
        60.00000762939453
      ],
      [
        -1255.4737548828125,
        3519.528076171875,
        60.0
      ],
      [
        -680.0,
        3790.339111328125,
        60.0
      ],
      [
        -417.7394104003906,
        3913.755859375,
        60.0
      ],
      [
        -820.0,
        3724.456787109375,
        60.0
      ],
      [
        -1255.4737548828125,
        3519.528076171875,
        60.00000762939453
      ],
      [
        -863.95654296875,
        4227.03515625,
        -3.546217918395996
      ],
      [
        -867.9923095703125,
        4213.97705078125,
        0.11537551879882812
      ],
      [
        -863.9566650390625,
        4227.03515625,
        -3.5464301109313965
      ],
      [
        -867.9923095703125,
        4213.97705078125,
        0.11537551879882812
      ],
      [
        -867.8943481445312,
        4212.85888671875,
        -2.3511455059051514
      ],
      [
        -866.7744750976562,
        4210.79541015625,
        -12.788475036621094
      ],
      [
        -867.531982421875,
        4208.72216796875,
        -11.47574520111084
      ],
      [
        -867.6137084960938,
        4209.6552734375,
        -9.417375564575195
      ],
      [
        -867.531982421875,
        4208.72216796875,
        -11.47574520111084
      ],
      [
        -866.7744750976562,
        4210.79541015625,
        -12.788475036621094
      ],
      [
        -838.721435546875,
        4311.7041015625,
        -2.460390090942383
      ],
      [
        -856.6905517578125,
        4243.3837890625,
        8.131248474121094
      ],
      [
        -866.7343139648438,
        4210.20263671875,
        18.98564338684082
      ],
      [
        -856.6904907226562,
        4243.3837890625,
        8.13133430480957
      ],
      [
        -866.7343139648438,
        4210.20263671875,
        18.98564338684082
      ],
      [
        -867.8943481445312,
        4212.85888671875,
        -2.3511457443237305
      ],
      [
        -866.3397216796875,
        4206.697265625,
        13.819272994995117
      ],
      [
        -853.1808471679688,
        4203.2939453125,
        -46.600006103515625
      ],
      [
        -827.6931762695312,
        4323.68310546875,
        -38.479679107666016
      ],
      [
        -855.1553955078125,
        4201.533203125,
        -39.77201843261719
      ],
      [
        -861.5934448242188,
        4196.490234375,
        -16.823261260986328
      ],
      [
        -867.6137084960938,
        4209.6552734375,
        -9.417348861694336
      ],
      [
        -864.36279296875,
        4189.134765625,
        -12.06310749053955
      ],
      [
        -864.8992919921875,
        4193.90087890625,
        -5.039201736450195
      ],
      [
        -864.3627319335938,
        4189.134765625,
        -12.063109397888184
      ],
      [
        -861.5934448242188,
        4196.490234375,
        -16.823261260986328
      ],
      [
        -835.7706298828125,
        4316.12841796875,
        -10.896333694458008
      ],
      [
        -828.2265014648438,
        4322.93359375,
        -36.90610122680664
      ],
      [
        -827.6932373046875,
        4323.68310546875,
        -38.479679107666016
      ],
      [
        -828.2263793945312,
        4322.93359375,
        -36.90605926513672
      ],
      [
        -855.1553955078125,
        4201.533203125,
        -39.77201843261719
      ],
      [
        -853.1808471679688,
        4203.2939453125,
        -46.600006103515625
      ],
      [
        -835.7706298828125,
        4316.12841796875,
        -10.896333694458008
      ],
      [
        -838.7213745117188,
        4311.7041015625,
        -2.4603424072265625
      ],
      [
        -864.6488647460938,
        4194.1552734375,
        45.069515228271484
      ],
      [
        -863.61376953125,
        4195.3203125,
        39.432647705078125
      ],
      [
        -863.61376953125,
        4195.3203125,
        39.432647705078125
      ],
      [
        -865.5552978515625,
        4206.666015625,
        36.670433044433594
      ],
      [
        -850.1790771484375,
        4164.974609375,
        -25.712322235107422
      ],
      [
        -845.4138793945312,
        4184.265625,
        -54.11735534667969
      ],
      [
        -841.4041137695312,
        4219.7841796875,
        -81.41926574707031
      ],
      [
        -847.8589477539062,
        4173.720703125,
        -39.428653717041016
      ],
      [
        -850.1790771484375,
        4164.974609375,
        -25.712322235107422
      ],
      [
        -847.85888671875,
        4173.720703125,
        -39.428653717041016
      ],
      [
        -845.4138793945312,
        4184.265625,
        -54.11735534667969
      ],
      [
        -865.5552978515625,
        4206.666015625,
        36.67045593261719
      ],
      [
        -863.7686767578125,
        4220.0,
        15.780710220336914
      ],
      [
        -839.630615234375,
        4112.24072265625,
        -29.829906463623047
      ],
      [
        -850.163330078125,
        4142.19384765625,
        -21.77863121032715
      ],
      [
        -854.5245361328125,
        4103.56201171875,
        7.916193962097168
      ],
      [
        -842.5807495117188,
        4085.844482421875,
        -9.60634708404541
      ],
      [
        -842.580810546875,
        4085.844482421875,
        -9.606355667114258
      ],
      [
        -843.1376953125,
        4099.52392578125,
        -15.428542137145996
      ],
      [
        -864.6488647460938,
        4194.1552734375,
        45.069515228271484
      ],
      [
        -852.7464599609375,
        4128.43994140625,
        58.219566345214844
      ],
      [
        -831.8681640625,
        4064.068603515625,
        -2.3831276893615723
      ],
      [
        -852.249755859375,
        4092.874267578125,
        33.08858871459961
      ],
      [
        -850.17822265625,
        4163.71923828125,
        -25.495567321777344
      ],
      [
        -831.8681640625,
        4064.068603515625,
        -2.383111000061035
      ],
      [
        -835.9271240234375,
        4097.79638671875,
        -16.17928123474121
      ],
      [
        -830.8889770507812,
        4062.078125,
        -1.7228710651397705
      ],
      [
        -843.2965087890625,
        4079.224609375,
        21.38886833190918
      ],
      [
        -830.888916015625,
        4062.078125,
        -1.7228507995605469
      ],
      [
        -835.4603881835938,
        4097.6845703125,
        -16.22787857055664
      ],
      [
        -828.0048828125,
        4095.8984375,
        -17.00411605834961
      ],
      [
        -826.3795166015625,
        4083.73046875,
        -12.060419082641602
      ],
      [
        -821.7122192382812,
        4032.39111328125,
        18.296939849853516
      ],
      [
        -820.6497802734375,
        4042.103271484375,
        4.1178364753723145
      ],
      [
        -820.9813842773438,
        4025.0,
        22.412063598632812
      ],
      [
        -821.7122192382812,
        4032.39111328125,
        18.296939849853516
      ],
      [
        -816.6947631835938,
        3995.0,
        33.389549255371094
      ],
      [
        -823.83740234375,
        3995.0,
        47.674835205078125
      ],
      [
        -819.1575317382812,
        4006.555908203125,
        32.68077087402344
      ],
      [
        -820.9813232421875,
        4025.0,
        22.412015914916992
      ],
      [
        -819.3895263671875,
        4007.64453125,
        32.61393356323242
      ],
      [
        -819.3895263671875,
        4007.644287109375,
        32.61400604248047
      ],
      [
        -836.0972900390625,
        4025.0,
        54.57796096801758
      ],
      [
        -828.1703491210938,
        4011.731689453125,
        56.340675354003906
      ],
      [
        -836.0972900390625,
        4025.0,
        54.57796096801758
      ],
      [
        -842.5725708007812,
        4055.0,
        60.000003814697266
      ],
      [
        -848.2136840820312,
        4092.019287109375,
        60.0
      ],
      [
        -850.68603515625,
        4106.70849609375,
        60.0
      ],
      [
        -848.2136840820312,
        4092.019287109375,
        60.0
      ],
      [
        -850.68603515625,
        4106.70849609375,
        60.000003814697266
      ],
      [
        -850.7467041015625,
        4108.64208984375,
        60.000003814697266
      ],
      [
        -839.3714599609375,
        4046.428466796875,
        60.0
      ],
      [
        -831.7755737304688,
        4025.0,
        60.0
      ],
      [
        -842.5725708007812,
        4055.0,
        60.0
      ],
      [
        -839.3714599609375,
        4046.428466796875,
        60.0
      ],
      [
        -822.7264404296875,
        4056.382080078125,
        -0.9489642381668091
      ],
      [
        -820.6497802734375,
        4042.103271484375,
        4.117836952209473
      ],
      [
        -822.19140625,
        4052.37646484375,
        0.678400993347168
      ],
      [
        -851.0811767578125,
        4119.30615234375,
        60.0
      ],
      [
        -852.7464599609375,
        4128.43994140625,
        58.219566345214844
      ],
      [
        -830.0000610351562,
        4021.387939453125,
        60.0
      ],
      [
        -831.7755737304688,
        4025.0,
        60.0
      ],
      [
        -822.5850830078125,
        4055.0,
        -0.1999516487121582
      ],
      [
        -822.5850830078125,
        4055.0,
        -0.19995081424713135
      ],
      [
        -822.7264404296875,
        4056.382080078125,
        -0.9489736557006836
      ],
      [
        -762.339111328125,
        4349.31884765625,
        -75.32184600830078
      ],
      [
        -756.6871337890625,
        4349.73876953125,
        -86.62580871582031
      ],
      [
        -750.7061767578125,
        4352.5322265625,
        -98.58769226074219
      ],
      [
        -756.6871337890625,
        4349.73876953125,
        -86.62580871582031
      ],
      [
        -741.9952392578125,
        4339.45849609375,
        -171.88424682617188
      ],
      [
        -750.7061767578125,
        4352.5322265625,
        -98.58769226074219
      ],
      [
        -748.2702026367188,
        4350.3642578125,
        -103.45964050292969
      ],
      [
        -800.0000610351562,
        4180.0,
        0.0
      ],
      [
        -800.0000610351562,
        4280.0,
        0.0
      ],
      [
        -715.0926513671875,
        4320.83349609375,
        -169.8148193359375
      ],
      [
        -806.0,
        4327.83740234375,
        -71.21659851074219
      ],
      [
        -775.1005859375,
        4343.90087890625,
        -49.7989501953125
      ],
      [
        -762.339111328125,
        4349.31884765625,
        -75.32184600830078
      ],
      [
        -806.0,
        4327.56396484375,
        -78.94766235351562
      ],
      [
        -806.0,
        4332.87060546875,
        -37.458824157714844
      ],
      [
        -781.839111328125,
        4343.103515625,
        -36.321842193603516
      ],
      [
        -775.1005859375,
        4343.90087890625,
        -49.7989501953125
      ],
      [
        -806.0,
        4327.83740234375,
        -71.21660614013672
      ],
      [
        -781.839111328125,
        4343.103515625,
        -36.321842193603516
      ],
      [
        -806.0,
        4332.87060546875,
        -37.458824157714844
      ],
      [
        -806.0,
        4330.1142578125,
        -29.04134750366211
      ],
      [
        -801.7568359375,
        4331.4853515625,
        -27.539926528930664
      ],
      [
        -784.9222412109375,
        4339.73095703125,
        -30.15558433532715
      ],
      [
        -801.7568359375,
        4331.4853515625,
        -27.539926528930664
      ],
      [
        -806.0,
        4330.1142578125,
        -29.041345596313477
      ],
      [
        -806.0,
        4329.47802734375,
        -24.863937377929688
      ],
      [
        -806.0,
        4090.626708984375,
        -19.29518699645996
      ],
      [
        -789.4931030273438,
        4086.672119140625,
        -21.013826370239258
      ],
      [
        -794.8358764648438,
        4064.617431640625,
        -10.328243255615234
      ],
      [
        -806.0,
        4061.321044921875,
        -6.573875904083252
      ],
      [
        -806.0,
        4327.30224609375,
        -10.577077865600586
      ],
      [
        -794.771728515625,
        4331.5166015625,
        -10.456666946411133
      ],
      [
        -788.5641479492188,
        4335.74755859375,
        -22.871742248535156
      ],
      [
        -788.5641479492188,
        4335.74755859375,
        -22.871742248535156
      ],
      [
        -794.771728515625,
        4331.5166015625,
        -10.456666946411133
      ],
      [
        -806.0,
        4327.30224609375,
        -10.577077865600586
      ],
      [
        -806.0,
        4323.1591796875,
        0.0
      ],
      [
        -800.0000610351562,
        4325.4365234375,
        0.0
      ],
      [
        -797.7779541015625,
        4055.0,
        -4.444146633148193
      ],
      [
        -806.0,
        4055.0,
        -3.0374555587768555
      ],
      [
        -806.0,
        4061.321044921875,
        -6.573880195617676
      ],
      [
        -794.8358764648438,
        4064.617431640625,
        -10.32824420928955
      ],
      [
        -806.0,
        4055.0,
        -3.0374560356140137
      ],
      [
        -797.7779541015625,
        4055.0,
        -4.444147109985352
      ],
      [
        -800.0,
        4043.72607421875,
        -4.76837158203125e-07
      ],
      [
        -806.0,
        4046.57373046875,
        -3.4965503914463625e-07
      ],
      [
        -799.0000610351562,
        4180.0,
        -2.0
      ],
      [
        -800.0000610351562,
        4180.0,
        0.0
      ],
      [
        -838.4636840820312,
        4310.83837890625,
        0.0
      ],
      [
        -822.4954833984375,
        4054.40283203125,
        0.0
      ],
      [
        -838.4636840820312,
        4310.83837890625,
        0.0
      ],
      [
        -842.8955688476562,
        4295.83349609375,
        0.0
      ],
      [
        -833.7548828125,
        4312.62548828125,
        0.0
      ],
      [
        -826.7225341796875,
        4287.3994140625,
        53.445003509521484
      ],
      [
        -840.4642944335938,
        4226.21435546875,
        60.0
      ],
      [
        -830.0000610351562,
        4256.3515625,
        60.0
      ],
      [
        -840.4642944335938,
        4226.21435546875,
        60.0
      ],
      [
        -853.3928833007812,
        4201.78564453125,
        60.000003814697266
      ],
      [
        -853.3928833007812,
        4201.78564453125,
        60.0
      ],
      [
        -853.0670776367188,
        4189.91845703125,
        60.0
      ],
      [
        -851.4605102539062,
        4131.400390625,
        60.0
      ],
      [
        -816.7775268554688,
        4305.9248046875,
        33.55497360229492
      ],
      [
        -819.4880981445312,
        4052.975341796875,
        -6.374733629854745e-08
      ],
      [
        -821.6834106445312,
        4032.654296875,
        17.912734985351562
      ],
      [
        -813.4331665039062,
        4050.1015625,
        -1.9209454649171676e-07
      ],
      [
        -803.8173217773438,
        4025.0,
        7.634557723999023
      ],
      [
        -803.0123291015625,
        4028.442626953125,
        6.024641990661621
      ],
      [
        -822.5000610351562,
        4298.60009765625,
        45.0
      ],
      [
        -816.7775268554688,
        4305.9248046875,
        33.55497360229492
      ],
      [
        -822.5000610351562,
        4298.60009765625,
        45.0
      ],
      [
        -826.7225341796875,
        4287.3994140625,
        53.445003509521484
      ],
      [
        -803.0123291015625,
        4028.442626953125,
        6.024641036987305
      ],
      [
        -803.8173217773438,
        4025.0,
        7.634557723999023
      ],
      [
        -851.4605102539062,
        4131.400390625,
        60.0
      ],
      [
        -647.5817260742188,
        4220.0,
        -30.229555130004883
      ],
      [
        -634.0,
        4160.0,
        -25.22104263305664
      ],
      [
        -634.0,
        4054.0,
        -23.249984741210938
      ],
      [
        -634.0,
        4054.0,
        -23.249980926513672
      ],
      [
        -564.0,
        4054.0,
        -21.450969696044922
      ],
      [
        -634.0,
        4208.0,
        -32.0
      ],
      [
        -634.0,
        4208.0,
        -26.426424026489258
      ],
      [
        -632.5031127929688,
        4208.0,
        -26.075117111206055
      ],
      [
        -628.0,
        4208.0,
        -25.95938491821289
      ],
      [
        -634.0,
        4264.0,
        -32.0
      ],
      [
        -634.0,
        4264.0,
        -29.29935073852539
      ],
      [
        -628.0,
        4264.0,
        -27.89121437072754
      ],
      [
        -636.0,
        4216.0,
        -27.306230545043945
      ],
      [
        -636.0,
        4208.0,
        -26.89581298828125
      ],
      [
        -636.0,
        4267.341796875,
        -32.0
      ],
      [
        -636.0,
        4264.283203125,
        -29.78326988220215
      ],
      [
        -636.0,
        4264.0,
        -29.76874351501465
      ],
      [
        -636.0,
        4208.0,
        -26.895809173583984
      ],
      [
        -636.0,
        4264.0,
        -29.768728256225586
      ],
      [
        -647.5817260742188,
        4220.0,
        -30.229557037353516
      ],
      [
        -651.0009765625,
        4231.34521484375,
        -31.614036560058594
      ],
      [
        -636.0,
        4272.0,
        -30.179141998291016
      ],
      [
        -636.0,
        4264.0,
        -29.578413009643555
      ],
      [
        -635.9567260742188,
        4264.0,
        -29.456775665283203
      ],
      [
        -628.0,
        4264.0,
        -27.68858528137207
      ],
      [
        -636.0,
        4264.0,
        -29.578256607055664
      ],
      [
        -636.0,
        4264.283203125,
        -29.78326988220215
      ],
      [
        -636.0,
        4216.0,
        -27.26063346862793
      ],
      [
        -650.9109497070312,
        4231.451171875,
        -31.2841854095459
      ],
      [
        -636.0,
        4272.0,
        -29.834033966064453
      ],
      [
        -636.0,
        4264.0,
        -29.466358184814453
      ],
      [
        -636.0,
        4264.0,
        -29.46639633178711
      ],
      [
        -679.2155151367188,
        4096.74169921875,
        -25.20681381225586
      ],
      [
        -675.7874145507812,
        4117.82763671875,
        -31.11025619506836
      ],
      [
        -647.9085693359375,
        4241.376953125,
        -27.202030181884766
      ],
      [
        -647.7692260742188,
        4241.91650390625,
        -27.0981388092041
      ],
      [
        -647.9085693359375,
        4241.376953125,
        -27.202030181884766
      ],
      [
        -650.6002807617188,
        4231.8173828125,
        -30.14589500427246
      ],
      [
        -650.6002807617188,
        4231.8173828125,
        -30.14589500427246
      ],
      [
        -636.0,
        4272.0,
        -27.35506248474121
      ],
      [
        -636.0,
        4264.0,
        -27.206302642822266
      ],
      [
        -636.0,
        4264.0,
        -27.20630645751953
      ],
      [
        -628.0,
        4264.0,
        -27.000709533691406
      ],
      [
        -636.0,
        4216.0,
        -26.313751220703125
      ],
      [
        -636.0,
        4208.0,
        -26.164993286132812
      ],
      [
        -636.0,
        4208.0,
        -26.164989471435547
      ],
      [
        -564.0,
        4054.0,
        -21.362525939941406
      ],
      [
        -573.4214477539062,
        4054.0,
        -21.69310188293457
      ],
      [
        -636.0,
        4264.0,
        -27.114425659179688
      ],
      [
        -628.0,
        4264.0,
        -26.833724975585938
      ],
      [
        -636.0,
        4272.0,
        -27.237319946289062
      ],
      [
        -636.0,
        4264.0,
        -27.11442756652832
      ],
      [
        -634.0,
        4198.0,
        -14.0
      ],
      [
        -634.0,
        4280.0,
        -14.0
      ],
      [
        -594.6071166992188,
        4310.75,
        -14.0
      ],
      [
        -596.4435424804688,
        4311.2822265625,
        -14.0
      ],
      [
        -634.0,
        4239.404296875,
        -24.3778018951416
      ],
      [
        -634.0,
        4296.4931640625,
        -18.18678092956543
      ],
      [
        -627.3117065429688,
        4323.8369140625,
        -14.761482238769531
      ],
      [
        -609.861083984375,
        4319.79150390625,
        -14.0
      ],
      [
        -596.4435424804688,
        4311.2822265625,
        -14.0
      ],
      [
        -634.0,
        4239.404296875,
        -24.377796173095703
      ],
      [
        -634.0,
        4224.314453125,
        -26.416963577270508
      ],
      [
        -628.0,
        4264.0,
        -21.29784393310547
      ],
      [
        -634.0,
        4264.0,
        -27.04425048828125
      ],
      [
        -634.0,
        4264.0,
        -21.71051025390625
      ],
      [
        -609.861083984375,
        4319.79150390625,
        -14.0
      ],
      [
        -627.311767578125,
        4323.8369140625,
        -14.76148509979248
      ],
      [
        -627.0797119140625,
        4324.1923828125,
        -14.0
      ],
      [
        -628.0,
        4264.0,
        -20.831274032592773
      ],
      [
        -634.0,
        4264.0,
        -21.041793823242188
      ],
      [
        -579.032958984375,
        4167.19970703125,
        -14.0
      ],
      [
        -579.4623413085938,
        4137.72509765625,
        -14.0
      ],
      [
        -579.032958984375,
        4167.19970703125,
        -14.0
      ],
      [
        -576.9285278320312,
        4217.642578125,
        -14.0
      ],
      [
        -580.6819458007812,
        4054.0,
        -14.0
      ],
      [
        -564.0,
        4054.0,
        -14.0
      ],
      [
        -593.1585083007812,
        4054.0,
        -22.200347900390625
      ],
      [
        -581.0516357421875,
        4198.0,
        -16.0
      ],
      [
        -577.7479858398438,
        4198.0,
        -14.0
      ],
      [
        -576.9285278320312,
        4217.642578125,
        -14.0
      ],
      [
        -578.250244140625,
        4220.93408203125,
        -14.0
      ],
      [
        -581.627197265625,
        4198.0,
        -16.0
      ],
      [
        -578.5842895507812,
        4198.0,
        -14.0
      ],
      [
        -587.857177734375,
        4244.85693359375,
        -14.0
      ],
      [
        -594.6071166992188,
        4310.75,
        -14.0
      ],
      [
        -587.857177734375,
        4244.85693359375,
        -14.0
      ],
      [
        -584.8187866210938,
        4198.0,
        -16.0
      ],
      [
        -583.05712890625,
        4198.0,
        -14.0
      ],
      [
        -634.0,
        4105.35986328125,
        -24.20502471923828
      ],
      [
        -634.0,
        4092.542724609375,
        -22.923748016357422
      ],
      [
        -634.0,
        4054.0,
        -19.0709171295166
      ],
      [
        -585.2229614257812,
        4054.0,
        -16.984619140625
      ],
      [
        -634.0,
        4092.542724609375,
        -22.923748016357422
      ],
      [
        -634.0,
        4058.0751953125,
        -16.025060653686523
      ],
      [
        -634.0,
        4054.0,
        -15.209454536437988
      ],
      [
        -584.1505737304688,
        4054.0,
        -16.27977752685547
      ],
      [
        -634.0,
        4054.0,
        -14.0
      ],
      [
        -634.0,
        4198.0,
        -16.0
      ],
      [
        -634.0,
        4198.0,
        -14.0
      ],
      [
        -634.0,
        4208.0,
        -16.0
      ],
      [
        -634.0,
        4208.0,
        -26.113588333129883
      ],
      [
        -634.0,
        4264.0,
        -16.0
      ],
      [
        -590.0,
        4179.0,
        -14.0
      ],
      [
        -570.3571166992188,
        4216.78564453125,
        -10.0
      ],
      [
        -585.259765625,
        4253.89599609375,
        -9.999999046325684
      ],
      [
        -591.0027465820312,
        4309.95849609375,
        -10.0
      ],
      [
        -570.3571166992188,
        4216.78564453125,
        -10.0
      ],
      [
        -585.259765625,
        4253.89599609375,
        -10.0
      ],
      [
        -583.05712890625,
        4198.0,
        -14.0
      ],
      [
        -580.0,
        4182.3349609375,
        -12.351056098937988
      ],
      [
        -594.4642333984375,
        4318.03564453125,
        -10.0
      ],
      [
        -625.860595703125,
        4326.060546875,
        -10.0
      ],
      [
        -591.0027465820312,
        4309.95849609375,
        -10.0
      ],
      [
        -594.4642333984375,
        4318.03564453125,
        -10.0
      ],
      [
        -646.0,
        4237.89501953125,
        -14.0
      ],
      [
        -636.7686767578125,
        4280.0,
        -14.0
      ],
      [
        -686.1090087890625,
        4056.26806640625,
        -15.422711372375488
      ],
      [
        -680.9696044921875,
        4084.892333984375,
        -21.037559509277344
      ],
      [
        -680.9696044921875,
        4084.892333984375,
        -21.037559509277344
      ],
      [
        -679.5257568359375,
        4094.83349609375,
        -24.672515869140625
      ],
      [
        -679.5257568359375,
        4094.83349609375,
        -24.672515869140625
      ],
      [
        -634.0,
        4094.90771484375,
        -23.160173416137695
      ],
      [
        -639.8030395507812,
        4272.7685546875,
        -21.158710479736328
      ],
      [
        -639.8030395507812,
        4272.76904296875,
        -21.158695220947266
      ],
      [
        -636.0,
        4272.0,
        -20.980510711669922
      ],
      [
        -636.0,
        4264.0,
        -21.848079681396484
      ],
      [
        -636.0,
        4264.0,
        -21.848079681396484
      ],
      [
        -634.0,
        4264.0,
        -21.71051788330078
      ],
      [
        -686.1090087890625,
        4056.26806640625,
        -15.422711372375488
      ],
      [
        -650.6138916015625,
        4052.0,
        -14.0
      ],
      [
        -686.7568359375,
        4052.0,
        -14.0
      ],
      [
        -646.0,
        4239.74169921875,
        -16.0
      ],
      [
        -646.0,
        4237.89501953125,
        -14.0
      ],
      [
        -646.0,
        4102.84228515625,
        -24.466611862182617
      ],
      [
        -646.0,
        4100.71826171875,
        -24.2542667388916
      ],
      [
        -679.078369140625,
        4040.0,
        -10.0
      ],
      [
        -688.5781860351562,
        4040.0,
        -10.0
      ],
      [
        -577.1483154296875,
        4054.0,
        -10.0
      ],
      [
        -564.0,
        4054.0,
        -2.0399789810180664
      ],
      [
        -568.486328125,
        4148.0,
        0.0
      ],
      [
        -567.16015625,
        4204.2060546875,
        0.0
      ],
      [
        -566.7857055664062,
        4214.64306640625,
        0.0
      ],
      [
        -567.16015625,
        4204.2060546875,
        0.0
      ],
      [
        -570.7042236328125,
        4054.0,
        0.0
      ],
      [
        -564.0,
        4054.0,
        0.0
      ],
      [
        -570.2196655273438,
        4054.0,
        -5.805384635925293
      ],
      [
        -566.7857055664062,
        4214.64306640625,
        4.76837158203125e-07
      ],
      [
        -566.8947143554688,
        4215.45751953125,
        4.7279419845835946e-07
      ],
      [
        -622.0,
        4054.0,
        0.0
      ],
      [
        -622.0,
        4148.0,
        0.0
      ],
      [
        -622.0,
        4100.0,
        0.0
      ],
      [
        -622.0,
        4054.0,
        0.0
      ],
      [
        -622.0,
        4090.0,
        0.0
      ],
      [
        -573.2142944335938,
        4262.66796875,
        0.0
      ],
      [
        -578.7662353515625,
        4276.49365234375,
        0.0
      ],
      [
        -578.7662353515625,
        4276.49365234375,
        0.0
      ],
      [
        -580.260986328125,
        4291.0849609375,
        0.0
      ],
      [
        -580.260986328125,
        4291.0849609375,
        0.0
      ],
      [
        -594.1071166992188,
        4323.39306640625,
        0.0
      ],
      [
        -597.99951171875,
        4324.3876953125,
        0.0
      ],
      [
        -594.1071166992188,
        4323.39306640625,
        0.0
      ],
      [
        -612.9099731445312,
        4322.75048828125,
        -10.0
      ],
      [
        -573.2142944335938,
        4262.66796875,
        2.384185791015625e-07
      ],
      [
        -591.5,
        4115.0,
        0.0
      ],
      [
        -621.0,
        4115.0,
        0.0
      ],
      [
        -622.0,
        4330.52197265625,
        0.0
      ],
      [
        -622.0,
        4325.07373046875,
        -10.0
      ],
      [
        -621.0,
        4100.0,
        0.0
      ],
      [
        -622.0,
        4100.0,
        0.0
      ],
      [
        -622.8129272460938,
        4330.72998046875,
        0.0
      ],
      [
        -690.1398315429688,
        4025.0,
        -1.4668891429901123
      ],
      [
        -679.9598999023438,
        4025.0,
        0.0
      ],
      [
        -694.67138671875,
        4002.97705078125,
        0.0
      ],
      [
        -689.2276000976562,
        4035.72119140625,
        -8.573766708374023
      ],
      [
        -626.1617431640625,
        4325.59912109375,
        -10.988151550292969
      ],
      [
        -623.31396484375,
        4330.85791015625,
        0.0
      ],
      [
        -671.11181640625,
        4332.88134765625,
        -14.530360221862793
      ],
      [
        -671.11181640625,
        4332.88134765625,
        -14.530357360839844
      ],
      [
        -670.860107421875,
        4332.6376953125,
        -14.0
      ],
      [
        -652.163818359375,
        4328.8857421875,
        -14.0
      ],
      [
        -646.9763793945312,
        4329.27783203125,
        -14.0
      ],
      [
        -646.689208984375,
        4329.20458984375,
        -14.0
      ],
      [
        -652.163818359375,
        4328.8857421875,
        -14.0
      ],
      [
        -649.3070678710938,
        4328.95263671875,
        -14.0
      ],
      [
        -649.3070678710938,
        4328.95263671875,
        -14.0
      ],
      [
        -646.9763793945312,
        4329.27783203125,
        -14.0
      ],
      [
        -651.5,
        4280.0,
        -14.0
      ],
      [
        -625.9202270507812,
        4331.52392578125,
        0.0
      ],
      [
        -647.0757446289062,
        4328.5703125,
        0.0
      ],
      [
        -625.9202270507812,
        4331.52392578125,
        0.0
      ],
      [
        -666.341064453125,
        4328.2587890625,
        -4.477062702178955
      ],
      [
        -664.721435546875,
        4328.15771484375,
        0.0
      ],
      [
        -647.0757446289062,
        4328.5703125,
        0.0
      ],
      [
        -666.341064453125,
        4328.2587890625,
        -4.477063179016113
      ],
      [
        -653.7052612304688,
        4270.0,
        -11.198090553283691
      ],
      [
        -655.9891967773438,
        4280.0,
        -10.367570877075195
      ],
      [
        -656.6195068359375,
        4280.0,
        -12.13838005065918
      ],
      [
        -654.8818359375,
        4274.037109375,
        -11.577675819396973
      ],
      [
        -653.9325561523438,
        4270.0,
        -11.83657455444336
      ],
      [
        -654.8818359375,
        4274.037109375,
        -11.577679634094238
      ],
      [
        -653.7052612304688,
        4270.0,
        -11.198089599609375
      ],
      [
        -653.9325561523438,
        4270.0,
        -11.836567878723145
      ],
      [
        -672.5657958984375,
        4333.1435546875,
        -14.449112892150879
      ],
      [
        -672.5657958984375,
        4333.1435546875,
        -14.449110984802246
      ],
      [
        -668.6649169921875,
        4328.15625,
        -2.916135787963867
      ],
      [
        -668.6649169921875,
        4328.15625,
        -2.916135787963867
      ],
      [
        -667.93798828125,
        4328.08251953125,
        0.0
      ],
      [
        -657.6298217773438,
        4270.0,
        -9.770984649658203
      ],
      [
        -659.6367797851562,
        4280.0,
        -9.041181564331055
      ],
      [
        -657.8714599609375,
        4270.0,
        -10.762325286865234
      ],
      [
        -659.0904541015625,
        4275.9501953125,
        -10.429871559143066
      ],
      [
        -657.6298217773438,
        4270.0,
        -9.770984649658203
      ],
      [
        -657.8714599609375,
        4270.0,
        -10.762322425842285
      ],
      [
        -660.0845947265625,
        4280.0,
        -10.878342628479004
      ],
      [
        -659.0904541015625,
        4275.9501953125,
        -10.429865837097168
      ],
      [
        -675.7902221679688,
        4321.98193359375,
        -31.3313045501709
      ],
      [
        -674.8861083984375,
        4333.56201171875,
        -14.3194580078125
      ],
      [
        -675.6288452148438,
        4321.99755859375,
        -30.516536712646484
      ],
      [
        -674.8861083984375,
        4333.56201171875,
        -14.3194580078125
      ],
      [
        -671.0460815429688,
        4328.05078125,
        -1.3166980743408203
      ],
      [
        -671.0460815429688,
        4328.05078125,
        -1.3166972398757935
      ],
      [
        -670.7720336914062,
        4328.01611328125,
        0.0
      ],
      [
        -659.8652954101562,
        4270.0,
        -8.958085060119629
      ],
      [
        -661.9074096679688,
        4280.0,
        -8.215494155883789
      ],
      [
        -660.1070556640625,
        4270.0,
        -10.152618408203125
      ],
      [
        -661.5783081054688,
        4277.0810546875,
        -9.751373291015625
      ],
      [
        -659.8652954101562,
        4270.0,
        -8.958085060119629
      ],
      [
        -660.1070556640625,
        4270.0,
        -10.152623176574707
      ],
      [
        -662.2844848632812,
        4280.0,
        -10.078377723693848
      ],
      [
        -661.5783081054688,
        4277.0810546875,
        -9.75136661529541
      ],
      [
        -675.7902221679688,
        4321.98193359375,
        -31.3313045501709
      ],
      [
        -675.6427612304688,
        4321.78076171875,
        -30.820173263549805
      ],
      [
        -675.6427612304688,
        4321.78076171875,
        -30.820173263549805
      ],
      [
        -692.5640258789062,
        4336.74951171875,
        -13.331647872924805
      ],
      [
        -671.1201782226562,
        4328.04736328125,
        -1.2669446468353271
      ],
      [
        -671.1201782226562,
        4328.04736328125,
        -1.2669439315795898
      ],
      [
        -670.9514770507812,
        4328.03857421875,
        -0.862064003944397
      ],
      [
        -692.5640258789062,
        4336.74951171875,
        -13.331647872924805
      ],
      [
        -675.3991088867188,
        4325.57470703125,
        -25.506729125976562
      ],
      [
        -752.4030151367188,
        4351.73974609375,
        -95.19405364990234
      ],
      [
        -780.0,
        4084.39794921875,
        -22.002214431762695
      ],
      [
        -780.0,
        4068.998046875,
        -15.317378044128418
      ],
      [
        -780.0,
        4002.030517578125,
        -1.171769618988037
      ],
      [
        -780.0,
        4006.986328125,
        0.0
      ],
      [
        -780.0,
        3995.0,
        0.0
      ],
      [
        -780.0,
        4002.030517578125,
        -1.1717698574066162
      ],
      [
        -780.0,
        4055.0,
        -7.48573637008667
      ],
      [
        -780.0,
        4037.573486328125,
        -1.2038911581039429
      ],
      [
        -783.8326416015625,
        4036.052734375,
        0.0
      ],
      [
        -800.0,
        4043.72607421875,
        0.0
      ],
      [
        -780.0,
        4055.0,
        -7.485735893249512
      ],
      [
        -780.0,
        4068.998046875,
        -15.317378997802734
      ],
      [
        -780.0,
        4337.06103515625,
        -10.298256874084473
      ],
      [
        -800.0000610351562,
        4325.4365234375,
        0.0
      ],
      [
        -780.0,
        4333.02734375,
        0.0
      ],
      [
        -780.0,
        4343.88232421875,
        -36.235294342041016
      ],
      [
        -780.0,
        4338.5146484375,
        -19.841350555419922
      ],
      [
        -780.0,
        4337.06103515625,
        -10.298256874084473
      ],
      [
        -780.0,
        4338.5146484375,
        -19.841350555419922
      ],
      [
        -780.0,
        4343.88232421875,
        -36.235294342041016
      ],
      [
        -780.0,
        4343.3212890625,
        -40.00008010864258
      ],
      [
        -783.8326416015625,
        4036.052734375,
        0.0
      ],
      [
        -780.0,
        4037.573486328125,
        -1.2038908004760742
      ],
      [
        -780.0,
        4034.802734375,
        5.3925599985404915e-08
      ],
      [
        -678.0,
        4116.64453125,
        -30.930999755859375
      ],
      [
        -678.0,
        4104.21826171875,
        -27.299997329711914
      ],
      [
        -678.0,
        4322.91796875,
        -31.435293197631836
      ],
      [
        -678.0,
        4321.763671875,
        -42.48577880859375
      ],
      [
        -678.0,
        4327.26806640625,
        -23.661916732788086
      ],
      [
        -675.6288452148438,
        4321.99755859375,
        -30.51654815673828
      ],
      [
        -678.0,
        4323.12939453125,
        -29.406274795532227
      ],
      [
        -678.0,
        4322.57275390625,
        -30.179004669189453
      ],
      [
        -678.0,
        4322.91796875,
        -31.43529510498047
      ],
      [
        -678.0,
        4322.57275390625,
        -30.179004669189453
      ],
      [
        -722.0,
        4339.810546875,
        -50.189369201660156
      ],
      [
        -722.0,
        4341.55322265625,
        -33.505882263183594
      ],
      [
        -722.0,
        4340.58154296875,
        -71.97188568115234
      ],
      [
        -722.0,
        4339.810546875,
        -50.189369201660156
      ],
      [
        -715.01318359375,
        4340.79736328125,
        -12.077230453491211
      ],
      [
        -678.0,
        4323.12939453125,
        -29.406274795532227
      ],
      [
        -715.01318359375,
        4340.79736328125,
        -12.077230453491211
      ],
      [
        -702.4977416992188,
        4336.06982421875,
        -6.0
      ],
      [
        -679.53271484375,
        4331.46142578125,
        -6.0
      ],
      [
        -722.0,
        4341.55322265625,
        -33.505882263183594
      ],
      [
        -722.0,
        4337.35693359375,
        -18.211002349853516
      ],
      [
        -722.0,
        4342.05712890625,
        -11.686820983886719
      ],
      [
        -722.0,
        4337.35693359375,
        -18.211002349853516
      ],
      [
        -722.0,
        4342.05712890625,
        -11.686820983886719
      ],
      [
        -722.0,
        4339.9833984375,
        -6.0
      ],
      [
        -722.0,
        4062.636962890625,
        -16.542476654052734
      ],
      [
        -722.0,
        4084.562744140625,
        -24.86656379699707
      ],
      [
        -722.0,
        4055.357177734375,
        -15.119101524353027
      ],
      [
        -722.0,
        4062.636962890625,
        -16.542476654052734
      ],
      [
        -716.801025390625,
        4028.0,
        -6.0
      ],
      [
        -722.0,
        4035.28125,
        -8.42709732055664
      ],
      [
        -722.0,
        4055.357177734375,
        -15.119101524353027
      ],
      [
        -707.5428466796875,
        4028.0,
        -6.0
      ],
      [
        -722.0,
        4035.28125,
        -8.42709732055664
      ],
      [
        -716.801025390625,
        4028.0,
        -6.0
      ],
      [
        -722.0,
        4029.695556640625,
        -6.0
      ],
      [
        -722.0,
        4084.562744140625,
        -24.86656379699707
      ],
      [
        -722.0,
        4093.117431640625,
        -27.36627769470215
      ],
      [
        -684.0,
        4190.0,
        -6.0
      ],
      [
        -684.0,
        4180.0,
        -6.0
      ],
      [
        -684.0,
        4180.0,
        -6.0
      ],
      [
        -722.0,
        3995.0,
        0.0
      ],
      [
        -722.0,
        4022.41943359375,
        -4.569901943206787
      ],
      [
        -722.0,
        4028.8837890625,
        -5.647270679473877
      ],
      [
        -696.0,
        4025.0,
        -2.3113152980804443
      ],
      [
        -696.0,
        4000.988037109375,
        0.0
      ],
      [
        -722.0,
        4337.7958984375,
        -3.465951863290684e-07
      ],
      [
        -696.0,
        4332.578125,
        -6.687601512567198e-07
      ],
      [
        -696.0,
        4334.76611328125,
        -6.0
      ],
      [
        -722.0,
        4025.0,
        -3.959711790084839
      ],
      [
        -722.0,
        4025.0,
        -3.959711790084839
      ],
      [
        -722.0,
        4022.41943359375,
        -4.569901466369629
      ],
      [
        -673.0062866210938,
        4327.9638671875,
        -9.5367431640625e-07
      ],
      [
        -673.0062866210938,
        4327.9638671875,
        0.0
      ],
      [
        -765.3046264648438,
        4055.0,
        -9.999937057495117
      ],
      [
        -780.0,
        4061.400390625,
        -11.06670093536377
      ],
      [
        -756.2420654296875,
        4047.0,
        -8.666616439819336
      ],
      [
        -722.0,
        4028.8837890625,
        -5.647252082824707
      ],
      [
        -765.3046264648438,
        4055.0,
        -9.999937057495117
      ],
      [
        -756.2420654296875,
        4047.0,
        -8.666617393493652
      ],
      [
        -722.0,
        4044.34765625,
        -11.44924545288086
      ],
      [
        -751.9642944335938,
        4355.0,
        -59.99995803833008
      ],
      [
        -722.0,
        4340.06982421875,
        -57.51160430908203
      ],
      [
        -751.9642944335938,
        4355.0,
        -59.99995803833008
      ],
      [
        -770.7718505859375,
        4345.73876953125,
        -58.45638656616211
      ],
      [
        -749.9425048828125,
        4025.0,
        0.0
      ],
      [
        -749.9425048828125,
        4025.0,
        4.76837158203125e-07
      ],
      [
        -747.888671875,
        4342.9912109375,
        -2.5809441694946145e-08
      ],
      [
        -767.0170288085938,
        4337.95458984375,
        0.0
      ],
      [
        -767.0170288085938,
        4337.95458984375,
        0.0
      ],
      [
        -765.013916015625,
        4338.595703125,
        0.0
      ],
      [
        -749.9716186523438,
        4343.4091796875,
        0.0
      ],
      [
        -749.9716186523438,
        4343.4091796875,
        0.0
      ],
      [
        -820.0,
        3995.0,
        60.0
      ],
      [
        -820.0,
        3724.456787109375,
        60.0
      ],
      [
        -821.2678833007812,
        4281.5,
        60.0
      ],
      [
        -820.6041870117188,
        4002.272705078125,
        60.0
      ],
      [
        -820.0,
        3995.0,
        60.0
      ],
      [
        -820.6041870117188,
        4002.272705078125,
        60.0
      ],
      [
        -825.0000610351562,
        4291.96875,
        50.000030517578125
      ],
      [
        -821.2678833007812,
        4281.5,
        60.0
      ],
      [
        -820.0000610351562,
        4281.90576171875,
        60.0
      ],
      [
        -568.4525756835938,
        4149.42919921875,
        0.0
      ],
      [
        -569.3199462890625,
        4175.6259765625,
        17.79701042175293
      ],
      [
        -569.3199462890625,
        4175.6259765625,
        17.79701042175293
      ],
      [
        -566.9539794921875,
        4148.0,
        35.0
      ],
      [
        -565.1642456054688,
        4118.427734375,
        35.0
      ],
      [
        -575.6767578125,
        4268.7998046875,
        0.0
      ],
      [
        -583.75,
        4201.78564453125,
        60.000003814697266
      ],
      [
        -585.685302734375,
        4131.400390625,
        60.0
      ],
      [
        -566.5,
        4084.5,
        60.000003814697266
      ],
      [
        -566.5,
        4084.5,
        37.519287109375
      ],
      [
        -586.5,
        4084.5,
        59.47856521606445
      ],
      [
        -586.5,
        4084.5,
        60.00000762939453
      ],
      [
        -566.5,
        4071.5,
        60.000003814697266
      ],
      [
        -566.5,
        4071.5,
        37.12683868408203
      ],
      [
        -566.5,
        4084.5,
        37.519287109375
      ],
      [
        -566.5,
        4084.5,
        60.00000762939453
      ],
      [
        -564.8756103515625,
        4060.129150390625,
        35.0
      ],
      [
        -565.0441284179688,
        4054.0,
        35.0
      ],
      [
        -565.0441284179688,
        4054.0,
        35.0
      ],
      [
        -564.0,
        4054.0,
        33.85357666015625
      ],
      [
        -580.0,
        4306.4287109375,
        35.0
      ],
      [
        -575.9090576171875,
        4295.97412109375,
        34.999996185302734
      ],
      [
        -569.75,
        4194.2021484375,
        35.0
      ],
      [
        -566.5,
        4071.5,
        35.0
      ],
      [
        -566.5,
        4084.5,
        35.0
      ],
      [
        -566.5,
        4084.5,
        35.0
      ],
      [
        -570.2350463867188,
        4084.5,
        3.0
      ],
      [
        -572.9059448242188,
        4084.5,
        35.0
      ],
      [
        -571.646240234375,
        4084.5,
        3.0
      ],
      [
        -573.6859741210938,
        4084.5,
        35.0
      ],
      [
        -622.0,
        4331.94189453125,
        2.6065139770507812
      ],
      [
        -615.3921508789062,
        4332.64697265625,
        7.0
      ],
      [
        -593.8571166992188,
        4327.14306640625,
        7.0
      ],
      [
        -622.0,
        4330.52197265625,
        0.0
      ],
      [
        -615.3921508789062,
        4332.64697265625,
        7.0
      ],
      [
        -622.0,
        4331.94189453125,
        2.6065139770507812
      ],
      [
        -622.0,
        4331.72412109375,
        7.0
      ],
      [
        -586.5,
        4084.5,
        7.0
      ],
      [
        -571.9011840820312,
        4084.5,
        7.0
      ],
      [
        -622.0,
        4330.4736328125,
        32.22807693481445
      ],
      [
        -580.0,
        4306.4287109375,
        35.0
      ],
      [
        -599.9660034179688,
        4323.3671875,
        35.0
      ],
      [
        -586.5,
        4084.5,
        35.0
      ],
      [
        -622.0,
        4148.0,
        8.0
      ],
      [
        -622.0,
        4150.0,
        10.0
      ],
      [
        -599.9660034179688,
        4323.3671875,
        35.0
      ],
      [
        -622.0,
        4330.4736328125,
        32.22807693481445
      ],
      [
        -622.0,
        4327.779296875,
        35.0
      ],
      [
        -622.0,
        4150.0,
        19.5
      ],
      [
        -622.0,
        4150.0,
        17.600000381469727
      ],
      [
        -622.0,
        4150.0,
        12.800000190734863
      ],
      [
        -622.0,
        4150.0,
        10.5
      ],
      [
        -622.0,
        4150.0,
        17.600000381469727
      ],
      [
        -622.0,
        4150.0,
        12.800000190734863
      ],
      [
        -622.0,
        4150.0,
        10.5
      ],
      [
        -622.0,
        4150.0,
        10.0
      ],
      [
        -614.9321899414062,
        4141.98388671875,
        10.0
      ],
      [
        -615.4581298828125,
        4141.4580078125,
        10.132560729980469
      ],
      [
        -622.0,
        4025.0,
        8.351783752441406
      ],
      [
        -622.0,
        4023.973388671875,
        8.450594902038574
      ],
      [
        -572.9058227539062,
        4084.5,
        35.0
      ],
      [
        -573.78369140625,
        4084.5,
        45.51653289794922
      ],
      [
        -572.8111572265625,
        4105.5068359375,
        35.0
      ],
      [
        -573.5050659179688,
        4084.5,
        35.0
      ],
      [
        -574.0167236328125,
        4084.5,
        45.77238464355469
      ],
      [
        -591.2843627929688,
        4235.28857421875,
        60.0
      ],
      [
        -598.6755981445312,
        4289.91064453125,
        60.0
      ],
      [
        -583.75,
        4201.78564453125,
        60.0
      ],
      [
        -591.2843627929688,
        4235.28857421875,
        60.0
      ],
      [
        -598.6755981445312,
        4289.91064453125,
        60.0
      ],
      [
        -612.4022216796875,
        4301.55615234375,
        60.0
      ],
      [
        -612.4022216796875,
        4301.55615234375,
        60.0
      ],
      [
        -622.0,
        4303.47802734375,
        60.0
      ],
      [
        -586.4232177734375,
        4106.70849609375,
        60.0
      ],
      [
        -585.685302734375,
        4131.400390625,
        60.0
      ],
      [
        -586.5,
        4084.5,
        59.358402252197266
      ],
      [
        -574.013671875,
        4084.5,
        45.70841598510742
      ],
      [
        -592.2896118164062,
        4069.076171875,
        60.0
      ],
      [
        -590.373046875,
        4081.60107421875,
        60.0
      ],
      [
        -590.373046875,
        4081.60107421875,
        60.0
      ],
      [
        -588.7788696289062,
        4092.019287109375,
        60.0
      ],
      [
        -586.4232177734375,
        4106.70849609375,
        60.000003814697266
      ],
      [
        -588.7788696289062,
        4092.019287109375,
        60.0
      ],
      [
        -586.5,
        4084.5,
        56.253814697265625
      ],
      [
        -573.8587036132812,
        4084.5,
        42.44525146484375
      ],
      [
        -576.4197998046875,
        4084.5,
        35.0
      ],
      [
        -577.5213623046875,
        4084.5,
        46.446128845214844
      ],
      [
        -693.21337890625,
        4327.06982421875,
        13.57320785522461
      ],
      [
        -679.2857055664062,
        4326.53076171875,
        41.42857360839844
      ],
      [
        -693.21337890625,
        4327.06982421875,
        13.573208808898926
      ],
      [
        -700.0,
        4333.380859375,
        -6.191962711454835e-07
      ],
      [
        -622.0,
        4328.0791015625,
        34.69157028198242
      ],
      [
        -632.7232055664062,
        4305.625,
        60.0
      ],
      [
        -670.3955688476562,
        4309.89111328125,
        59.2088737487793
      ],
      [
        -670.0,
        4309.052734375,
        60.0
      ],
      [
        -679.2857055664062,
        4326.53076171875,
        41.42857360839844
      ],
      [
        -670.3955688476562,
        4309.89111328125,
        59.20886993408203
      ],
      [
        -632.7232055664062,
        4305.625,
        60.0
      ],
      [
        -625.0,
        4115.0,
        11.0
      ],
      [
        -622.0,
        4115.0,
        11.0
      ],
      [
        -623.2857055664062,
        4150.0,
        11.0
      ],
      [
        -622.0,
        4150.0,
        11.0
      ],
      [
        -623.2857055664062,
        4150.0,
        11.0
      ],
      [
        -624.0,
        4150.0,
        11.0
      ],
      [
        -680.0,
        3790.339111328125,
        60.0
      ],
      [
        -680.0,
        3995.0,
        60.0
      ],
      [
        -680.0,
        4309.44091796875,
        60.0
      ],
      [
        -671.5625,
        4309.1962890625,
        60.0
      ],
      [
        -675.0,
        4318.50927734375,
        50.00000762939453
      ],
      [
        -671.5625,
        4309.1962890625,
        60.0
      ],
      [
        -763.6785888671875,
        4299.9287109375,
        60.0
      ],
      [
        -736.25,
        4311.0712890625,
        60.0
      ],
      [
        -763.6785888671875,
        4299.9287109375,
        60.0
      ],
      [
        -736.25,
        4311.0712890625,
        60.000003814697266
      ],
      [
        -729.470947265625,
        4310.875,
        60.000003814697266
      ],
      [
        -691.3638916015625,
        4309.7705078125,
        60.0
      ],
      [
        -712.0,
        4274.0,
        60.0
      ],
      [
        -708.0,
        4274.0,
        60.0
      ],
      [
        -796.0,
        4274.0,
        60.0
      ],
      [
        -792.0,
        4274.0,
        60.0
      ],
      [
        -792.0,
        4274.0,
        60.0
      ],
      [
        -792.0,
        4278.0,
        60.0
      ],
      [
        -796.0,
        4278.0,
        60.0
      ],
      [
        -796.0,
        4274.0,
        60.0
      ],
      [
        -712.0,
        4278.0,
        60.0
      ],
      [
        -712.0,
        4274.0,
        60.0
      ],
      [
        -708.0,
        4274.0,
        60.0
      ],
      [
        -708.0,
        4278.0,
        60.0
      ],
      [
        -712.0,
        4310.36865234375,
        60.000003814697266
      ],
      [
        -708.0,
        4310.2529296875,
        60.000003814697266
      ],
      [
        -708.0,
        4314.97998046875,
        54.86920928955078
      ],
      [
        -712.0,
        4316.232421875,
        53.63555908203125
      ],
      [
        -712.0,
        4182.0,
        60.0
      ],
      [
        -708.0,
        4182.0,
        60.0
      ],
      [
        -796.0,
        4182.0,
        60.0
      ],
      [
        -792.0,
        4182.0,
        60.0
      ],
      [
        -712.0,
        4186.0,
        60.0
      ],
      [
        -712.0,
        4182.0,
        60.0
      ],
      [
        -708.0,
        4182.0,
        60.0
      ],
      [
        -708.0,
        4186.0,
        60.0
      ],
      [
        -796.0,
        4186.0,
        60.0
      ],
      [
        -796.0,
        4182.0,
        60.0
      ],
      [
        -792.0,
        4182.0,
        60.0
      ],
      [
        -792.0,
        4186.0,
        60.0
      ],
      [
        4198.9326171875,
        4083.81396484375,
        0.0
      ],
      [
        3882.013916015625,
        3949.286376953125,
        -300.0
      ],
      [
        4235.86474609375,
        4094.98095703125,
        21.506088256835938
      ],
      [
        4212.03857421875,
        4089.37744140625,
        12.406579971313477
      ],
      [
        4198.9326171875,
        4083.814208984375,
        0.0
      ],
      [
        4208.05615234375,
        4088.44091796875,
        10.885597229003906
      ],
      [
        4208.05615234375,
        4088.44091796875,
        10.885599136352539
      ],
      [
        3326.666748046875,
        3338.333251953125,
        60.0
      ],
      [
        4074.680908203125,
        3963.45263671875,
        60.0
      ],
      [
        4074.680908203125,
        3963.45263671875,
        60.0
      ],
      [
        4232.7275390625,
        4057.1025390625,
        60.0
      ],
      [
        -572.9041748046875,
        632.4712524414062,
        -182.7124786376953
      ],
      [
        -529.2625122070312,
        886.0882568359375,
        -51.78752136230469
      ],
      [
        -556.3078002929688,
        389.2561950683594,
        -300.0
      ],
      [
        -572.9041748046875,
        632.4712524414062,
        -182.71249389648438
      ],
      [
        -554.7374267578125,
        976.0254516601562,
        -16.02838134765625
      ],
      [
        -589.6880493164062,
        1042.7884521484375,
        -7.560673713684082
      ],
      [
        -620.8946533203125,
        1102.39990234375,
        0.0
      ],
      [
        -589.6880493164062,
        1042.7884521484375,
        -7.5606689453125
      ],
      [
        -529.2625122070312,
        886.0881958007812,
        -51.78758239746094
      ],
      [
        -554.7374267578125,
        976.0254516601562,
        -16.028392791748047
      ],
      [
        -548.4221801757812,
        959.0679321289062,
        -18.599721908569336
      ],
      [
        -620.8946533203125,
        1102.39990234375,
        0.0
      ],
      [
        -633.5274658203125,
        1125.6324462890625,
        2.8694369792938232
      ],
      [
        -643.7997436523438,
        1295.707763671875,
        37.369415283203125
      ],
      [
        -641.1093139648438,
        1249.369140625,
        27.951784133911133
      ],
      [
        -641.1093139648438,
        1249.369140625,
        27.951786041259766
      ],
      [
        -633.9725952148438,
        1126.451171875,
        2.970548152923584
      ],
      [
        -633.9725952148438,
        1126.451171875,
        2.970550537109375
      ],
      [
        -592.125244140625,
        1492.0,
        60.0
      ],
      [
        -620.7415771484375,
        1384.28173828125,
        60.0
      ],
      [
        -644.6181030273438,
        1309.8021240234375,
        40.23390579223633
      ],
      [
        -644.6181030273438,
        1309.8021240234375,
        40.23390197753906
      ],
      [
        -1550.0,
        2550.0,
        60.0
      ],
      [
        -2386.681884765625,
        2550.0,
        18.14398193359375
      ],
      [
        -2131.697265625,
        2550.0,
        60.00000762939453
      ],
      [
        -1530.0,
        2550.0,
        0.0
      ],
      [
        -1430.0,
        2550.0,
        -300.0
      ],
      [
        884.0,
        2570.0,
        0.0
      ],
      [
        884.0,
        2550.0,
        0.0
      ],
      [
        784.0,
        2550.0,
        -300.0
      ],
      [
        784.0,
        2670.0,
        -300.0
      ],
      [
        884.0,
        2550.0,
        0.0
      ],
      [
        884.0,
        2570.0,
        0.0
      ],
      [
        896.0,
        2550.0,
        60.0
      ],
      [
        -1530.0,
        2550.0,
        0.0
      ],
      [
        -1530.0,
        2550.0,
        60.0
      ],
      [
        -1870.0,
        2019.0977783203125,
        -10.0
      ],
      [
        -2208.427490234375,
        2280.1982421875,
        -10.0
      ],
      [
        434.6666564941406,
        1842.583740234375,
        -10.0
      ],
      [
        434.6666564941406,
        2415.303466796875,
        -10.000000953674316
      ],
      [
        434.6666564941406,
        2415.303466796875,
        -10.0
      ],
      [
        880.6666870117188,
        2419.303466796875,
        -10.000000953674316
      ],
      [
        880.6666870117188,
        2419.303466796875,
        -10.0
      ],
      [
        880.6666870117188,
        2550.0,
        -10.000000953674316
      ],
      [
        -1526.6666259765625,
        2550.0,
        -10.0
      ],
      [
        -1526.6666259765625,
        2096.666748046875,
        -10.0
      ],
      [
        -1526.6666259765625,
        2096.666748046875,
        -10.0
      ],
      [
        -1846.6666259765625,
        2096.666748046875,
        -10.0
      ],
      [
        -1846.6666259765625,
        2096.666748046875,
        -10.0
      ],
      [
        -1826.5699462890625,
        1702.2269287109375,
        -70.29023742675781
      ],
      [
        -1846.6666259765625,
        2001.095947265625,
        -10.0
      ],
      [
        -1871.4102783203125,
        2000.0,
        -14.2948579788208
      ],
      [
        -1846.593017578125,
        2000.0,
        -10.221088409423828
      ],
      [
        -1855.392333984375,
        1950.0,
        -22.30381202697754
      ],
      [
        -1843.23095703125,
        1950.0,
        -20.307514190673828
      ],
      [
        -1840.0,
        2000.0,
        -10.0
      ],
      [
        -1840.0,
        1950.0,
        -19.777145385742188
      ],
      [
        -1840.0,
        1995.9525146484375,
        -10.0
      ],
      [
        -1840.0,
        2000.0,
        -10.0
      ],
      [
        -1845.2462158203125,
        2000.0,
        -10.0
      ],
      [
        -1840.0,
        1950.0,
        -19.777149200439453
      ],
      [
        205.60003662109375,
        1744.39990234375,
        -10.0
      ],
      [
        317.7317199707031,
        1819.3238525390625,
        -10.000000953674316
      ],
      [
        130.67605590820312,
        1632.268310546875,
        -10.0
      ],
      [
        205.60003662109375,
        1744.39990234375,
        -10.000000953674316
      ],
      [
        317.7317199707031,
        1819.3238525390625,
        -10.0
      ],
      [
        434.6666564941406,
        1842.583740234375,
        -10.000000953674316
      ],
      [
        107.416259765625,
        1515.3333740234375,
        -10.0
      ],
      [
        130.67605590820312,
        1632.268310546875,
        -10.000000953674316
      ],
      [
        436.0,
        2415.3154296875,
        -10.0
      ],
      [
        896.0,
        2404.0,
        60.0
      ],
      [
        896.0,
        2404.0,
        60.0
      ],
      [
        -1530.0,
        2100.0,
        60.0
      ],
      [
        -1530.0,
        2096.666748046875,
        -10.0
      ],
      [
        -1986.276123046875,
        2253.754150390625,
        20.840042114257812
      ],
      [
        -1965.0274658203125,
        2096.666748046875,
        -10.0
      ],
      [
        -1965.4854736328125,
        2096.964599609375,
        -9.10666275024414
      ],
      [
        -1530.0,
        2100.0,
        60.0
      ],
      [
        -1850.0,
        2100.0,
        10.496261596679688
      ],
      [
        -1548.4259033203125,
        2100.0,
        60.0
      ],
      [
        -1850.0,
        2050.667724609375,
        0.0
      ],
      [
        -1964.865234375,
        2092.287353515625,
        -10.0
      ],
      [
        -1850.0,
        2100.0,
        10.496256828308105
      ],
      [
        -1850.0,
        2050.66748046875,
        0.0
      ],
      [
        -1840.0,
        2000.0,
        -9.138838768005371
      ],
      [
        -1840.0,
        2000.0,
        -9.138837814331055
      ],
      [
        129.996337890625,
        1628.85107421875,
        -10.000000953674316
      ],
      [
        321.1487731933594,
        1820.0035400390625,
        -10.0
      ],
      [
        203.66444396972656,
        1741.5030517578125,
        -10.000000953674316
      ],
      [
        -2399.8955078125,
        2570.0,
        20.230213165283203
      ],
      [
        -1530.0,
        2570.0,
        60.00000762939453
      ],
      [
        -2157.6201171875,
        2570.0,
        60.00000762939453
      ],
      [
        896.0,
        2570.0,
        60.0
      ],
      [
        -1530.0,
        2570.0,
        60.0
      ],
      [
        896.0,
        2696.0,
        60.0
      ],
      [
        896.0,
        2704.0,
        60.0
      ],
      [
        1196.0,
        2704.0,
        60.0
      ],
      [
        1200.0,
        2704.0,
        60.0
      ],
      [
        896.0,
        2704.0,
        60.0
      ],
      [
        1199.1688232421875,
        2843.0390625,
        56.88316345214844
      ],
      [
        1200.0,
        2842.0,
        60.0
      ],
      [
        1199.1688232421875,
        2843.0390625,
        56.88315963745117
      ],
      [
        2920.0,
        3166.5,
        60.0
      ],
      [
        2780.0,
        3104.0,
        60.0
      ],
      [
        3326.666748046875,
        3338.333251953125,
        60.0
      ],
      [
        2920.0,
        3166.5,
        60.0
      ],
      [
        1758.0,
        2919.23779296875,
        0.0
      ],
      [
        1658.0,
        2984.889892578125,
        -300.0
      ],
      [
        2780.0,
        3104.0,
        60.0
      ],
      [
        2660.6015625,
        3104.0,
        60.0
      ],
      [
        1879.7591552734375,
        2972.0,
        0.0
      ],
      [
        1875.2353515625,
        2993.816650390625,
        -65.44963073730469
      ],
      [
        1897.669677734375,
        2979.76123046875,
        0.0
      ],
      [
        1875.2353515625,
        2993.816650390625,
        -65.44961547851562
      ],
      [
        1879.7591552734375,
        2972.0,
        0.0
      ],
      [
        1902.3670654296875,
        2960.0,
        60.0
      ],
      [
        1909.86181640625,
        2963.247802734375,
        60.0
      ],
      [
        1897.669677734375,
        2979.76123046875,
        0.0
      ],
      [
        1758.0,
        2919.23779296875,
        0.0
      ],
      [
        1770.0,
        2902.640869140625,
        60.0
      ],
      [
        1778.0,
        2960.0,
        60.0
      ],
      [
        1906.3404541015625,
        3046.0,
        60.0
      ],
      [
        2399.764892578125,
        3184.25732421875,
        60.0
      ],
      [
        2099.170654296875,
        3054.0,
        60.0
      ],
      [
        2099.170654296875,
        3054.0,
        60.0
      ],
      [
        1906.0,
        3054.0,
        60.0
      ],
      [
        1906.0,
        3054.0,
        60.0
      ],
      [
        -2657.889892578125,
        3369.26904296875,
        60.000003814697266
      ],
      [
        -2774.392822265625,
        3276.8701171875,
        60.000003814697266
      ],
      [
        -498.0,
        4036.5,
        150.0
      ],
      [
        -498.0,
        4051.5,
        200.0
      ],
      [
        -536.0,
        4061.5,
        170.0
      ],
      [
        -536.0,
        4061.5,
        180.0
      ],
      [
        -536.0,
        4061.5,
        205.0
      ],
      [
        -536.0,
        4061.5,
        180.0
      ],
      [
        -536.0,
        4091.5,
        185.0
      ],
      [
        -536.0,
        4091.5,
        170.0
      ],
      [
        -536.0,
        4047.63916015625,
        180.0
      ],
      [
        -536.0,
        4061.5,
        180.0
      ],
      [
        -536.0,
        4047.63916015625,
        185.0
      ],
      [
        -536.0,
        4047.63916015625,
        180.0
      ],
      [
        -536.0,
        4060.5,
        170.0
      ],
      [
        -536.0,
        4060.5,
        180.0
      ],
      [
        -571.5,
        4084.5,
        150.0
      ],
      [
        -571.5,
        4084.5,
        60.000003814697266
      ],
      [
        -566.5,
        4061.5,
        180.0
      ],
      [
        -566.5,
        4061.5,
        170.0
      ],
      [
        -566.5,
        4061.5,
        205.0
      ],
      [
        -566.5,
        4061.5,
        180.0
      ],
      [
        -566.5,
        4055.464599609375,
        180.0
      ],
      [
        -566.5,
        4061.5,
        180.0
      ],
      [
        -566.5,
        4055.464599609375,
        185.0
      ],
      [
        -566.5,
        4055.464599609375,
        180.0
      ],
      [
        -574.0,
        4084.5,
        150.0
      ],
      [
        -574.0,
        4084.5,
        60.000003814697266
      ],
      [
        -574.0,
        4051.5,
        200.0
      ],
      [
        -574.0,
        4036.5,
        150.0
      ],
      [
        -830.5,
        4898.5,
        221.0
      ],
      [
        -830.5,
        4898.5,
        237.0
      ],
      [
        -830.5,
        4898.5,
        242.0
      ],
      [
        -830.5,
        4898.5,
        258.0
      ],
      [
        -830.5,
        4898.5,
        200.0
      ],
      [
        -830.5,
        4898.5,
        216.0
      ],
      [
        -749.0621948242188,
        4898.5,
        200.0
      ],
      [
        -749.0621948242188,
        4898.5,
        250.0
      ],
      [
        -830.5,
        4898.5,
        242.0
      ],
      [
        -2507.482421875,
        5022.517578125,
        256.0171813964844
      ],
      [
        -2498.34765625,
        5000.0,
        258.5180358886719
      ],
      [
        -2498.34765625,
        5000.0,
        258.51800537109375
      ],
      [
        -2507.914306640625,
        4977.9140625,
        263.9595642089844
      ],
      [
        -2507.914306640625,
        4977.9140625,
        263.9595642089844
      ],
      [
        -2530.0,
        4969.1591796875,
        269.06781005859375
      ],
      [
        -574.0,
        4084.5,
        109.66455078125
      ],
      [
        -586.5,
        4084.5,
        111.68104553222656
      ],
      [
        -698.0,
        4207.2666015625,
        108.0
      ],
      [
        -698.0,
        4282.0,
        94.80926513671875
      ],
      [
        -1025.4019775390625,
        3884.597900390625,
        217.76953125
      ],
      [
        -1017.7234497070312,
        3865.670166015625,
        219.87164306640625
      ],
      [
        -1022.034912109375,
        3864.912841796875,
        280.0
      ],
      [
        -1083.7291259765625,
        3860.0,
        231.52066040039062
      ],
      [
        -1077.965087890625,
        3855.087158203125,
        280.0
      ],
      [
        -1081.3984375,
        3854.48388671875,
        232.11830139160156
      ],
      [
        -722.0,
        4282.0,
        98.68099975585938
      ],
      [
        -722.0,
        4229.2021484375,
        108.0
      ],
      [
        -698.0,
        4212.724609375,
        107.03661346435547
      ],
      [
        -698.0,
        4282.0,
        92.52159118652344
      ],
      [
        -722.0,
        4282.0,
        95.65808868408203
      ],
      [
        -722.0,
        4223.0966796875,
        108.0
      ],
      [
        -782.0,
        4260.51953125,
        108.0
      ],
      [
        -782.0,
        4282.0,
        103.49923706054688
      ],
      [
        -806.0,
        4282.0,
        106.63568878173828
      ],
      [
        -806.0,
        4275.48876953125,
        108.0
      ],
      [
        -1083.741943359375,
        3860.0,
        231.35340881347656
      ],
      [
        -1082.17626953125,
        3856.324951171875,
        231.91883850097656
      ],
      [
        -981.3683471679688,
        3928.6318359375,
        155.26559448242188
      ],
      [
        -959.5238037109375,
        3875.894287109375,
        165.0
      ],
      [
        -959.5238037109375,
        3875.894287109375,
        150.9368438720703
      ],
      [
        -574.0,
        4084.5,
        88.72222900390625
      ],
      [
        -586.5,
        4084.5,
        90.82362365722656
      ],
      [
        -981.3683471679688,
        3928.6318359375,
        155.26559448242188
      ],
      [
        -1030.0,
        3950.0,
        163.70712280273438
      ],
      [
        -1003.3914794921875,
        3868.187744140625,
        175.0
      ],
      [
        -1017.3741455078125,
        3865.7314453125,
        215.0
      ],
      [
        -1096.6083984375,
        3851.81201171875,
        175.0
      ],
      [
        -1082.6258544921875,
        3854.268310546875,
        215.0
      ],
      [
        -1082.6258544921875,
        3854.268310546875,
        215.0
      ],
      [
        -1100.455078125,
        3860.0,
        174.4312286376953
      ],
      [
        -1096.6083984375,
        3851.81201171875,
        175.0
      ],
      [
        -1097.482666015625,
        3851.658447265625,
        173.82769775390625
      ],
      [
        -1017.3741455078125,
        3865.7314453125,
        215.0
      ],
      [
        -981.3683471679688,
        3928.6318359375,
        154.45249938964844
      ],
      [
        -959.5238037109375,
        3875.894287109375,
        150.06488037109375
      ],
      [
        -981.3683471679688,
        3928.6318359375,
        154.45249938964844
      ],
      [
        -1030.0,
        3950.0,
        162.86141967773438
      ],
      [
        -1101.23095703125,
        3860.0,
        173.46139526367188
      ],
      [
        -1098.2196044921875,
        3851.529052734375,
        172.83953857421875
      ],
      [
        -806.0,
        4282.0,
        101.81290435791016
      ],
      [
        -806.0,
        4157.80224609375,
        100.19775390625
      ],
      [
        -782.0,
        4153.72119140625,
        104.27885437011719
      ],
      [
        -782.0,
        4271.0,
        105.80402374267578
      ],
      [
        -800.4846801757812,
        3995.0,
        99.03060913085938
      ],
      [
        -801.1341552734375,
        3903.719482421875,
        97.73164367675781
      ],
      [
        -800.0,
        3903.918701171875,
        100.0
      ],
      [
        -806.0,
        4157.80224609375,
        100.19775390625
      ],
      [
        -796.0000610351562,
        4150.0,
        108.0
      ],
      [
        -799.33447265625,
        4156.6689453125,
        101.33120727539062
      ],
      [
        -800.4846801757812,
        3995.0,
        99.03060913085938
      ],
      [
        -800.7645263671875,
        3998.340087890625,
        99.02583312988281
      ],
      [
        -800.7645263671875,
        3998.340087890625,
        99.02583312988281
      ],
      [
        -800.4610595703125,
        3998.32666015625,
        99.07792663574219
      ],
      [
        -794.8571166992188,
        3995.0,
        100.0
      ],
      [
        -800.0,
        3903.918701171875,
        100.0
      ],
      [
        -788.13818359375,
        3906.002685546875,
        100.0
      ],
      [
        -782.0,
        4153.72119140625,
        104.27885437011719
      ],
      [
        -792.218017578125,
        3997.95849609375,
        100.49307250976562
      ],
      [
        -794.8571166992188,
        3995.0,
        100.0
      ],
      [
        -792.218017578125,
        3997.95849609375,
        100.49307250976562
      ],
      [
        -795.090087890625,
        3998.086669921875,
        100.0
      ],
      [
        -959.5238037109375,
        3875.894287109375,
        150.0
      ],
      [
        -2483.3916015625,
        3608.18798828125,
        175.0
      ],
      [
        -2497.374267578125,
        3605.731689453125,
        215.0
      ],
      [
        -2475.190185546875,
        3636.67236328125,
        150.0
      ],
      [
        -2464.748291015625,
        3611.463134765625,
        150.0
      ],
      [
        -2483.3916015625,
        3608.18798828125,
        175.0
      ],
      [
        -2497.374267578125,
        3605.731689453125,
        215.0
      ],
      [
        -2498.052490234375,
        3605.6123046875,
        224.4607696533203
      ],
      [
        -2504.16162109375,
        3619.9794921875,
        226.51478576660156
      ],
      [
        -2530.0,
        3634.649169921875,
        219.5601806640625
      ],
      [
        -2525.771728515625,
        3633.24853515625,
        215.0
      ],
      [
        -1115.2518310546875,
        3848.536865234375,
        150.0
      ],
      [
        -2530.0,
        3634.207763671875,
        225.30062866210938
      ],
      [
        -2505.90966796875,
        3624.09033203125,
        227.10247802734375
      ],
      [
        -2505.90966796875,
        3624.09033203125,
        227.10247802734375
      ],
      [
        -800.613525390625,
        3995.0,
        98.77296447753906
      ],
      [
        -801.3544311523438,
        3903.680908203125,
        97.2911376953125
      ],
      [
        -800.613525390625,
        3995.0,
        98.77296447753906
      ],
      [
        -800.9605712890625,
        3999.196533203125,
        98.7760238647461
      ],
      [
        -800.9605712890625,
        3999.196533203125,
        98.7760238647461
      ],
      [
        -800.4610595703125,
        3998.32666015625,
        99.07792663574219
      ],
      [
        -800.57958984375,
        3999.181884765625,
        98.84082794189453
      ],
      [
        -793.4246215820312,
        3995.0,
        100.0
      ],
      [
        -785.7227783203125,
        3906.427001953125,
        100.0
      ],
      [
        -790.0650634765625,
        3998.77685546875,
        100.62948608398438
      ],
      [
        -793.4246215820312,
        3995.0,
        100.0
      ],
      [
        -795.090087890625,
        3998.086669921875,
        100.0
      ],
      [
        -790.0650634765625,
        3998.77685546875,
        100.62948608398438
      ],
      [
        -793.7654418945312,
        3998.91943359375,
        100.0
      ],
      [
        -700.0,
        3921.486572265625,
        100.0
      ],
      [
        -806.0,
        4282.0,
        100.0
      ],
      [
        -806.0,
        4158.0,
        100.0
      ],
      [
        -782.0,
        4158.0,
        100.0
      ],
      [
        -782.0,
        4282.0,
        100.0
      ],
      [
        -782.0,
        4104.31005859375,
        103.57240295410156
      ],
      [
        -802.9468383789062,
        4104.5068359375,
        100.0
      ],
      [
        -788.5347290039062,
        4069.1533203125,
        100.0
      ],
      [
        -782.0,
        4072.56787109375,
        101.3570556640625
      ],
      [
        -782.0,
        4006.316162109375,
        100.0
      ],
      [
        -793.7655029296875,
        3998.91943359375,
        100.0
      ],
      [
        -782.0,
        4001.843017578125,
        101.1405029296875
      ],
      [
        -782.0,
        4001.843017578125,
        101.1405029296875
      ],
      [
        -782.0,
        3995.0,
        100.0
      ],
      [
        -806.0,
        4193.07373046875,
        100.65644073486328
      ],
      [
        -782.0,
        4192.1904296875,
        104.77914428710938
      ],
      [
        -782.0,
        4210.45166015625,
        100.0
      ],
      [
        -806.0,
        4195.58203125,
        100.0
      ],
      [
        -806.0,
        4158.0,
        100.0
      ],
      [
        -782.0,
        4158.0,
        100.0
      ],
      [
        -782.0,
        4072.56787109375,
        101.3570556640625
      ],
      [
        -788.5347290039062,
        4069.1533203125,
        100.0
      ],
      [
        -782.0,
        4055.331298828125,
        100.0
      ],
      [
        -722.0,
        4261.27783203125,
        100.0
      ],
      [
        -722.0,
        4158.0,
        100.0
      ],
      [
        -639.7717895507812,
        4104.5068359375,
        100.0
      ],
      [
        -722.0,
        4103.7529296875,
        113.69612121582031
      ],
      [
        -722.0,
        4103.58642578125,
        113.68498992919922
      ],
      [
        -653.903076171875,
        4069.1533203125,
        100.0
      ],
      [
        -698.0,
        4158.0,
        100.0
      ],
      [
        -698.0,
        4246.30810546875,
        100.0
      ],
      [
        -722.0,
        4073.976318359375,
        111.45972442626953
      ],
      [
        -698.0,
        4055.0,
        106.12249755859375
      ],
      [
        -698.0,
        4091.450927734375,
        108.86186981201172
      ],
      [
        -722.0,
        4103.58642578125,
        113.68498992919922
      ],
      [
        -722.0,
        4024.653076171875,
        104.94218444824219
      ],
      [
        -722.0,
        3995.0,
        100.0
      ],
      [
        -698.0,
        4046.89697265625,
        104.93565368652344
      ],
      [
        -698.0,
        4025.0,
        101.36725616455078
      ],
      [
        -698.0,
        4025.0,
        101.36725616455078
      ],
      [
        -698.0,
        4000.613037109375,
        100.0
      ],
      [
        -722.0,
        4025.0,
        104.85374450683594
      ],
      [
        -722.0,
        4054.92724609375,
        109.95455932617188
      ],
      [
        -722.0,
        4054.92724609375,
        109.95455932617188
      ],
      [
        -722.0,
        4055.0,
        109.96566772460938
      ],
      [
        -722.0,
        4025.0,
        104.85374450683594
      ],
      [
        -722.0,
        4024.653076171875,
        104.94218444824219
      ],
      [
        -722.0,
        4158.0,
        100.0
      ],
      [
        -698.0,
        4158.0,
        100.0
      ],
      [
        -698.0,
        4055.0,
        106.12249755859375
      ],
      [
        -698.0,
        4046.89697265625,
        104.93565368652344
      ],
      [
        -722.0,
        4055.0,
        109.96566772460938
      ],
      [
        -722.0,
        4073.976318359375,
        111.45972442626953
      ],
      [
        -660.4300537109375,
        4055.0,
        100.0
      ],
      [
        -653.903076171875,
        4069.1533203125,
        100.0
      ],
      [
        -660.4300537109375,
        4055.0,
        100.0
      ],
      [
        -674.8108520507812,
        4039.0,
        100.0
      ],
      [
        -698.0,
        4021.005859375,
        101.14332580566406
      ],
      [
        -690.5694580078125,
        4021.466796875,
        100.0
      ],
      [
        -674.8108520507812,
        4039.0,
        100.0
      ],
      [
        -689.310546875,
        4025.0,
        100.0
      ],
      [
        -689.310546875,
        4025.0,
        100.0
      ],
      [
        -760.5357055664062,
        4223.75,
        100.0
      ],
      [
        -726.25,
        4263.9287109375,
        100.0
      ],
      [
        -760.5357055664062,
        4223.75,
        100.0
      ],
      [
        -781.8433227539062,
        4055.0,
        100.0
      ],
      [
        -741.7911987304688,
        4017.129150390625,
        103.68818664550781
      ],
      [
        -753.4762573242188,
        3995.0,
        100.0
      ],
      [
        -764.1360473632812,
        4017.546630859375,
        100.0
      ],
      [
        -741.7910766601562,
        4017.129150390625,
        103.68819427490234
      ],
      [
        -767.1663208007812,
        4039.0,
        100.0
      ],
      [
        -781.8433227539062,
        4055.0,
        100.0
      ],
      [
        -724.4043579101562,
        4023.739013671875,
        104.78984069824219
      ],
      [
        -726.8047485351562,
        3995.0,
        100.0
      ],
      [
        -753.576416015625,
        4024.18505859375,
        100.0
      ],
      [
        -724.404296875,
        4023.739013671875,
        104.78984832763672
      ],
      [
        -752.2802124023438,
        4025.0,
        100.0
      ],
      [
        -767.1663208007812,
        4039.0,
        100.0
      ],
      [
        -752.2802124023438,
        4025.0,
        100.0
      ],
      [
        -809.8214111328125,
        4193.21435546875,
        100.0
      ],
      [
        -806.0,
        3995.0,
        88.00001525878906
      ],
      [
        -806.0,
        3902.86474609375,
        88.0
      ],
      [
        -806.0,
        4241.4345703125,
        88.0
      ],
      [
        -806.0,
        4195.58203125,
        100.0
      ],
      [
        -800.0000610351562,
        4199.29931640625,
        100.0
      ],
      [
        -806.0,
        4104.53564453125,
        99.47929382324219
      ],
      [
        -806.0,
        4060.02734375,
        96.37300872802734
      ],
      [
        -801.3284912109375,
        4062.46826171875,
        97.34313201904297
      ],
      [
        -800.0000610351562,
        4097.2783203125,
        100.0
      ],
      [
        -803.9031982421875,
        3995.0,
        92.19364166259766
      ],
      [
        -805.0701904296875,
        4017.149658203125,
        93.53971099853516
      ],
      [
        -805.0701904296875,
        4017.149658203125,
        93.53971099853516
      ],
      [
        -800.57958984375,
        3999.181884765625,
        98.84082794189453
      ],
      [
        -803.0604858398438,
        4017.08203125,
        93.87905883789062
      ],
      [
        -806.0,
        4025.305908203125,
        91.4411392211914
      ],
      [
        -804.06640625,
        4025.98779296875,
        91.86730194091797
      ],
      [
        -801.649169921875,
        4055.0,
        96.70173645019531
      ],
      [
        -806.0,
        4055.0,
        95.97720336914062
      ],
      [
        -806.0,
        3995.0,
        88.00000762939453
      ],
      [
        -806.0,
        4021.21142578125,
        92.35501098632812
      ],
      [
        -806.0,
        4024.98681640625,
        91.39240264892578
      ],
      [
        -806.0,
        4021.21142578125,
        92.35501098632812
      ],
      [
        -804.1521606445312,
        4024.95849609375,
        91.69578552246094
      ],
      [
        -800.0000610351562,
        4158.0,
        100.0
      ],
      [
        -806.0,
        4055.0,
        95.97720336914062
      ],
      [
        -801.649169921875,
        4055.0,
        96.70173645019531
      ],
      [
        -801.3284912109375,
        4062.46826171875,
        97.34313201904297
      ],
      [
        -806.0,
        4060.02734375,
        96.37300872802734
      ],
      [
        -806.0,
        4025.0,
        91.3890151977539
      ],
      [
        -804.1578979492188,
        4025.0,
        91.68429565429688
      ],
      [
        -804.06640625,
        4025.98779296875,
        91.86730194091797
      ],
      [
        -806.0,
        4025.305908203125,
        91.4411392211914
      ],
      [
        -804.1578979492188,
        4025.0,
        91.68429565429688
      ],
      [
        -806.0,
        4025.0,
        91.3890151977539
      ],
      [
        -782.0,
        4210.45166015625,
        100.0
      ],
      [
        -782.0,
        4242.7958984375,
        91.53521728515625
      ],
      [
        -790.9642944335938,
        4250.75,
        88.0
      ],
      [
        -790.9642944335938,
        4250.75,
        88.0
      ],
      [
        -782.0,
        4242.7958984375,
        91.53521728515625
      ],
      [
        -782.0,
        4261.25537109375,
        88.0
      ],
      [
        -803.0604858398438,
        4017.08203125,
        93.87906646728516
      ],
      [
        -782.0,
        4006.316162109375,
        100.0
      ],
      [
        -782.0,
        4016.374755859375,
        97.43529510498047
      ],
      [
        -782.0,
        4033.76904296875,
        96.7306900024414
      ],
      [
        -782.0,
        4055.0,
        99.97390747070312
      ],
      [
        -804.1521606445312,
        4024.95849609375,
        91.69578552246094
      ],
      [
        -782.0,
        4024.619873046875,
        95.3330078125
      ],
      [
        -782.0,
        4025.0,
        95.236083984375
      ],
      [
        -782.0,
        4033.76904296875,
        96.7306900024414
      ],
      [
        -782.0,
        4025.0,
        95.236083984375
      ],
      [
        -782.0,
        4055.0,
        99.97390747070312
      ],
      [
        -782.0,
        4055.331298828125,
        100.0
      ],
      [
        -782.0,
        4280.529296875,
        71.6063232421875
      ],
      [
        -782.0,
        4294.06591796875,
        60.0
      ],
      [
        -806.0,
        4286.3857421875,
        60.0
      ],
      [
        -806.0,
        4264.9873046875,
        78.34767150878906
      ],
      [
        -782.0,
        4264.228515625,
        87.43057250976562
      ],
      [
        -782.0,
        4280.529296875,
        71.6063232421875
      ],
      [
        -796.0,
        4278.0,
        69.93383026123047
      ],
      [
        -796.0,
        4274.0,
        73.36336517333984
      ],
      [
        -792.0,
        4274.0,
        74.46088409423828
      ],
      [
        -792.0,
        4278.0,
        71.0313491821289
      ],
      [
        -796.0,
        4274.0,
        73.36336517333984
      ],
      [
        -792.0,
        4274.0,
        74.46088409423828
      ],
      [
        -782.0,
        4261.4541015625,
        87.96192169189453
      ],
      [
        -782.0,
        4264.228515625,
        87.43057250976562
      ],
      [
        -796.0,
        4255.21826171875,
        86.01409149169922
      ],
      [
        -792.0,
        4251.6689453125,
        87.591552734375
      ],
      [
        -792.0,
        4260.7041015625,
        85.86121368408203
      ],
      [
        -796.0,
        4260.404296875,
        85.02093505859375
      ],
      [
        -796.0,
        4247.6298828125,
        88.0
      ],
      [
        -792.0,
        4250.1083984375,
        88.0
      ],
      [
        -792.0,
        4251.6689453125,
        87.591552734375
      ],
      [
        -796.0,
        4255.21826171875,
        86.01409149169922
      ],
      [
        -806.0,
        4246.7099609375,
        86.61932373046875
      ],
      [
        -806.0,
        4256.01318359375,
        81.06988525390625
      ],
      [
        -806.0,
        4246.7099609375,
        86.61932373046875
      ],
      [
        -806.0,
        4264.9873046875,
        78.34767150878906
      ],
      [
        -806.0,
        4256.01318359375,
        81.06987762451172
      ],
      [
        -820.0,
        3900.4052734375,
        60.0
      ],
      [
        -841.4994506835938,
        4052.126708984375,
        60.0
      ],
      [
        -810.9906616210938,
        4251.6982421875,
        78.01882934570312
      ],
      [
        -806.5326538085938,
        4245.1748046875,
        86.93473815917969
      ],
      [
        -818.0914916992188,
        4278.064453125,
        63.81708908081055
      ],
      [
        -810.9906616210938,
        4251.6982421875,
        78.0188217163086
      ],
      [
        -820.0000610351562,
        4281.90576171875,
        60.0
      ],
      [
        -818.0914916992188,
        4278.064453125,
        63.81708908081055
      ],
      [
        -806.5326538085938,
        4245.1748046875,
        86.93473815917969
      ],
      [
        -806.0,
        4241.43408203125,
        88.00008392333984
      ],
      [
        -818.0787353515625,
        3995.0,
        63.84248352050781
      ],
      [
        -806.0,
        4023.6435546875,
        91.73487091064453
      ],
      [
        -819.7106323242188,
        3995.0,
        60.578739166259766
      ],
      [
        -830.0809326171875,
        4021.552490234375,
        60.0
      ],
      [
        -806.0,
        4023.677490234375,
        91.72620391845703
      ],
      [
        -806.0,
        4023.911376953125,
        91.66658782958984
      ],
      [
        -806.0,
        4024.98681640625,
        91.39240264892578
      ],
      [
        -700.0,
        3921.486572265625,
        100.0
      ],
      [
        -698.0,
        3921.837890625,
        96.0
      ],
      [
        -698.0,
        3995.0,
        96.0
      ],
      [
        -700.0,
        4158.0,
        100.0
      ],
      [
        -698.0,
        4162.0,
        95.99995422363281
      ],
      [
        -698.0,
        4000.613037109375,
        100.0
      ],
      [
        -698.0,
        3995.905029296875,
        99.73604583740234
      ],
      [
        -722.0,
        4276.50146484375,
        96.81025695800781
      ],
      [
        -698.0,
        4277.73828125,
        93.41460418701172
      ],
      [
        -698.0,
        4283.2294921875,
        88.0
      ],
      [
        -712.8624877929688,
        4284.59619140625,
        88.0
      ],
      [
        -722.0,
        4279.15380859375,
        94.19491577148438
      ],
      [
        -722.0,
        4279.15380859375,
        94.19491577148438
      ],
      [
        -712.8624877929688,
        4284.59619140625,
        88.0
      ],
      [
        -722.0,
        4284.861328125,
        88.0
      ],
      [
        -612.0821533203125,
        4105.16748046875,
        88.0
      ],
      [
        -609.9069213867188,
        4177.95458984375,
        88.0
      ],
      [
        -574.0,
        4084.5,
        88.0
      ],
      [
        -586.5,
        4084.5,
        88.0
      ],
      [
        -694.0,
        3922.54052734375,
        88.0
      ],
      [
        -694.0,
        3995.0,
        88.0
      ],
      [
        -622.7803955078125,
        4057.3447265625,
        91.34513854980469
      ],
      [
        -622.675537109375,
        4058.2275390625,
        91.37813568115234
      ],
      [
        -616.7158813476562,
        4104.88916015625,
        93.05646514892578
      ],
      [
        -622.6754760742188,
        4058.2275390625,
        91.37811279296875
      ],
      [
        -622.9095458984375,
        4056.25732421875,
        91.30450439453125
      ],
      [
        -622.7803955078125,
        4057.3447265625,
        91.34513854980469
      ],
      [
        -621.8231811523438,
        4250.95361328125,
        88.0
      ],
      [
        -609.4166870117188,
        4195.78564453125,
        88.0
      ],
      [
        -612.0821533203125,
        4105.16748046875,
        88.0
      ],
      [
        -619.0262451171875,
        4061.865478515625,
        88.0
      ],
      [
        -619.6773071289062,
        4057.610595703125,
        88.0
      ],
      [
        -619.3218994140625,
        4059.933349609375,
        88.0
      ],
      [
        -619.3218994140625,
        4059.933349609375,
        88.0
      ],
      [
        -619.0262451171875,
        4061.865478515625,
        88.0
      ],
      [
        -696.6089477539062,
        4277.81005859375,
        93.21778869628906
      ],
      [
        -659.7303466796875,
        4279.7109375,
        88.0
      ],
      [
        -694.0,
        4282.86181640625,
        88.0
      ],
      [
        -609.4166870117188,
        4195.78564453125,
        88.0
      ],
      [
        -609.9069213867188,
        4177.95458984375,
        88.0
      ],
      [
        -778.8826904296875,
        4264.908203125,
        88.0
      ],
      [
        -782.0,
        4261.25537109375,
        88.0
      ],
      [
        -778.8826904296875,
        4264.908203125,
        88.0
      ],
      [
        -729.25,
        4285.0712890625,
        88.0
      ],
      [
        -729.25,
        4285.0712890625,
        88.0
      ],
      [
        -680.0,
        3925.0,
        60.0
      ],
      [
        -604.7216796875,
        4295.0400390625,
        60.0
      ],
      [
        -684.3269653320312,
        4301.59326171875,
        68.65387725830078
      ],
      [
        -694.0,
        4282.86181640625,
        88.0
      ],
      [
        -684.3269653320312,
        4301.59326171875,
        68.65387725830078
      ],
      [
        -680.0,
        4309.44091796875,
        60.0
      ],
      [
        2846.4951171875,
        2916.415771484375,
        134.9307403564453
      ],
      [
        2780.0,
        2873.02001953125,
        90.72346496582031
      ],
      [
        2846.4951171875,
        2916.415771484375,
        134.93072509765625
      ],
      [
        2772.085693359375,
        3104.0,
        60.0
      ],
      [
        2747.231689453125,
        3104.0,
        60.0
      ],
      [
        -800.0,
        3779.540771484375,
        100.0
      ],
      [
        -700.0,
        3827.5,
        100.0
      ],
      [
        -995.4127807617188,
        3822.7900390625,
        150.0
      ],
      [
        -1005.7930297851562,
        3846.014404296875,
        175.0
      ],
      [
        -1008.3741455078125,
        3867.3125,
        189.2537841796875
      ],
      [
        -1012.0440673828125,
        3860.0,
        207.11758422851562
      ],
      [
        -1005.7930297851562,
        3846.014404296875,
        175.0
      ],
      [
        -1012.0440673828125,
        3860.0,
        207.1175994873047
      ],
      [
        -1014.807373046875,
        3866.182373046875,
        207.6572723388672
      ],
      [
        -1013.2730712890625,
        3862.749755859375,
        207.3576202392578
      ],
      [
        -1091.3170166015625,
        3839.03759765625,
        175.0
      ],
      [
        -1114.498046875,
        3846.716796875,
        150.0
      ],
      [
        -1091.317138671875,
        3839.03759765625,
        175.0
      ],
      [
        -2727.478759765625,
        3432.651611328125,
        150.0
      ],
      [
        -2675.35693359375,
        3397.963623046875,
        151.1754913330078
      ],
      [
        -2488.374267578125,
        3607.312744140625,
        189.25404357910156
      ],
      [
        -2515.952392578125,
        3566.086669921875,
        202.3816375732422
      ],
      [
        -2530.0,
        3563.197021484375,
        210.19200134277344
      ],
      [
        -2556.6064453125,
        3573.3935546875,
        207.99404907226562
      ],
      [
        -2530.0,
        3563.197021484375,
        210.19200134277344
      ],
      [
        -2523.431640625,
        3566.593017578125,
        211.99273681640625
      ],
      [
        -2512.462646484375,
        3572.264404296875,
        215.0
      ],
      [
        -2497.0625,
        3603.284423828125,
        224.12794494628906
      ],
      [
        -2512.462646484375,
        3572.264404296875,
        215.0
      ],
      [
        -2505.94384765625,
        3575.09326171875,
        216.67196655273438
      ],
      [
        -1064.3924560546875,
        3815.96142578125,
        175.0
      ],
      [
        -1104.8099365234375,
        3823.32763671875,
        150.0
      ],
      [
        -1086.2135009765625,
        3805.0,
        150.0
      ],
      [
        -1064.3924560546875,
        3815.96142578125,
        175.0
      ],
      [
        -2495.666015625,
        3600.0,
        223.65838623046875
      ],
      [
        -2505.3505859375,
        3575.3505859375,
        216.82411193847656
      ],
      [
        -2495.666015625,
        3600.0,
        223.65838623046875
      ],
      [
        -2505.3505859375,
        3575.3505859375,
        216.82411193847656
      ],
      [
        -1029.0372314453125,
        3818.682861328125,
        175.0
      ],
      [
        -1062.825439453125,
        3795.3125,
        150.0
      ],
      [
        -1036.7161865234375,
        3795.502197265625,
        150.0
      ],
      [
        -1029.0374755859375,
        3818.682861328125,
        175.0
      ],
      [
        -1013.328125,
        3805.18994140625,
        150.0
      ],
      [
        -820.0,
        3769.948974609375,
        60.0
      ],
      [
        -800.0,
        3779.540771484375,
        100.0
      ],
      [
        -700.0,
        3827.5,
        100.0
      ],
      [
        -680.0,
        3837.092041015625,
        60.0
      ],
      [
        -1530.0,
        2570.0,
        163.0246124267578
      ],
      [
        -1550.0,
        2550.0,
        155.48629760742188
      ],
      [
        -1530.0,
        2570.0,
        163.02464294433594
      ],
      [
        -1530.0,
        2550.0,
        60.0
      ],
      [
        -1530.0,
        2550.0,
        158.76931762695312
      ],
      [
        896.0,
        2550.0,
        60.0
      ],
      [
        896.0,
        2570.0,
        60.0
      ],
      [
        900.0,
        2570.0,
        80.0
      ],
      [
        900.0,
        2550.0,
        80.0
      ],
      [
        -1530.0,
        2100.0,
        63.02464294433594
      ],
      [
        -1530.0,
        2100.0,
        63.02463912963867
      ],
      [
        1910.0,
        2971.470703125,
        62.54904556274414
      ],
      [
        1909.49755859375,
        2971.80859375,
        60.0
      ],
      [
        -2840.601806640625,
        3237.04296875,
        89.81185913085938
      ],
      [
        -2678.753662109375,
        3390.609130859375,
        149.05308532714844
      ],
      [
        -2672.9677734375,
        3396.373779296875,
        151.22933959960938
      ],
      [
        -2678.753662109375,
        3390.609130859375,
        149.05308532714844
      ],
      [
        -2672.9677734375,
        3396.37353515625,
        151.2293701171875
      ],
      [
        916.1912231445312,
        322.2516784667969,
        60.0
      ],
      [
        567.1552734375,
        467.8068542480469,
        60.0
      ],
      [
        153.632080078125,
        786.84423828125,
        60.0
      ],
      [
        153.63214111328125,
        786.84423828125,
        60.0
      ],
      [
        -465.7703552246094,
        189.26101684570312,
        -171.80690002441406
      ],
      [
        -540.6758422851562,
        636.1808471679688,
        -86.02753448486328
      ],
      [
        -469.004638671875,
        214.6519775390625,
        -163.94961547851562
      ],
      [
        -540.6758422851562,
        636.1808471679688,
        -86.02752685546875
      ],
      [
        -521.8115234375,
        887.6137084960938,
        -29.43457794189453
      ],
      [
        -521.8115234375,
        887.6136474609375,
        -29.434600830078125
      ],
      [
        7800.0,
        -150.0,
        843.8387451171875
      ],
      [
        7634.89453125,
        -980.0414428710938,
        550.0692749023438
      ],
      [
        7712.08544921875,
        291.9754333496094,
        976.300048828125
      ],
      [
        7800.0,
        -150.0,
        843.8386840820312
      ],
      [
        7686.90869140625,
        -718.5485229492188,
        976.300048828125
      ],
      [
        7612.7041015625,
        -1091.6004638671875,
        884.7465209960938
      ],
      [
        788.9476318359375,
        296.69171142578125,
        60.0
      ],
      [
        -464.8707580566406,
        190.33880615234375,
        -168.4440460205078
      ],
      [
        -5174.01171875,
        5224.01171875,
        766.327392578125
      ],
      [
        -4708.220703125,
        5535.2431640625,
        976.300048828125
      ],
      [
        -1687.3155517578125,
        2570.0,
        200.0
      ],
      [
        -2518.133544921875,
        2570.0,
        63.63722610473633
      ],
      [
        -2496.7783203125,
        2550.0,
        58.56208801269531
      ],
      [
        -1635.0394287109375,
        2550.0,
        200.0
      ],
      [
        -1530.0,
        2550.0,
        200.0
      ],
      [
        -1530.0,
        2550.0,
        158.76931762695312
      ],
      [
        -1548.4200439453125,
        2568.420166015625,
        222.11924743652344
      ],
      [
        -1531.769287109375,
        2568.230712890625,
        224.7708740234375
      ],
      [
        -1531.255126953125,
        2551.255126953125,
        217.5726318359375
      ],
      [
        -1531.7694091796875,
        2568.230712890625,
        224.77088928222656
      ],
      [
        -1548.4200439453125,
        2568.420166015625,
        222.11924743652344
      ],
      [
        -1548.9588623046875,
        2551.041015625,
        214.57510375976562
      ],
      [
        -1548.958984375,
        2551.041015625,
        214.57504272460938
      ],
      [
        -1531.255126953125,
        2551.255126953125,
        217.57261657714844
      ],
      [
        -1530.0,
        2509.814453125,
        200.0
      ],
      [
        -1530.0,
        2279.609130859375,
        101.23937225341797
      ],
      [
        -2208.28271484375,
        2279.8134765625,
        -10.0
      ],
      [
        -2207.5810546875,
        2279.545166015625,
        -10.0
      ],
      [
        -2982.139404296875,
        3224.859375,
        268.42193603515625
      ],
      [
        -3460.14404296875,
        3452.2265625,
        287.5096435546875
      ],
      [
        -2982.139404296875,
        3224.859619140625,
        268.42193603515625
      ],
      [
        -3086.993408203125,
        3102.758056640625,
        198.8289794921875
      ],
      [
        -5174.01171875,
        5224.01171875,
        766.327392578125
      ],
      [
        -5242.5185546875,
        5121.48388671875,
        711.0977783203125
      ],
      [
        -2528.425537109375,
        3564.010986328125,
        210.62364196777344
      ],
      [
        -5579.1611328125,
        4617.6630859375,
        976.300048828125
      ],
      [
        -5573.556640625,
        4626.05029296875,
        901.11328125
      ],
      [
        -1846.6666259765625,
        1800.0,
        -10.0
      ],
      [
        -1846.666748046875,
        1750.0,
        -10.0
      ],
      [
        -1846.6666259765625,
        1326.6666259765625,
        -10.0
      ],
      [
        -1849.3822021484375,
        1326.6666259765625,
        -10.0
      ],
      [
        -1843.23095703125,
        1950.0,
        -20.307514190673828
      ],
      [
        -1846.666748046875,
        1950.0,
        -10.000000953674316
      ],
      [
        -1846.593017578125,
        2000.0,
        -10.221089363098145
      ],
      [
        -1846.666748046875,
        2000.0,
        -10.0
      ],
      [
        -2005.371337890625,
        2240.303955078125,
        60.0
      ],
      [
        -1994.9449462890625,
        1958.7901611328125,
        60.0
      ],
      [
        -1994.9449462890625,
        1958.7901611328125,
        60.0
      ],
      [
        -2025.5614013671875,
        1805.707763671875,
        60.0
      ],
      [
        -2025.5614013671875,
        1805.707763671875,
        60.0
      ],
      [
        -2086.65283203125,
        1652.97900390625,
        60.0
      ],
      [
        -2086.65283203125,
        1652.97900390625,
        60.0
      ],
      [
        -2135.39697265625,
        1579.8629150390625,
        60.0
      ],
      [
        -2500.695068359375,
        2550.0,
        60.0
      ],
      [
        -2488.017578125,
        2550.0,
        60.0
      ],
      [
        -1972.3970947265625,
        1350.0,
        60.000003814697266
      ],
      [
        -2048.84375,
        1350.0,
        60.000003814697266
      ],
      [
        -1955.1954345703125,
        1350.0,
        25.620227813720703
      ],
      [
        -1955.9825439453125,
        1330.0,
        28.673858642578125
      ],
      [
        -2041.31298828125,
        1330.0,
        60.0
      ],
      [
        -1971.6563720703125,
        1330.0,
        60.0
      ],
      [
        -1880.0,
        1800.0,
        0.0
      ],
      [
        -1850.0,
        1800.0,
        0.0
      ],
      [
        -1850.0001220703125,
        1750.0,
        0.0
      ],
      [
        -1850.0001220703125,
        2000.0,
        0.0
      ],
      [
        -1880.0,
        1950.0,
        0.0
      ],
      [
        -1850.0001220703125,
        1950.0,
        -9.5367431640625e-07
      ],
      [
        -1870.0,
        1330.0,
        60.000003814697266
      ],
      [
        -1870.0,
        1350.0,
        60.0
      ],
      [
        -1880.0,
        1800.0,
        60.0
      ],
      [
        -1870.0,
        1800.0,
        60.0
      ],
      [
        -1850.0001220703125,
        1750.0,
        0.0
      ],
      [
        -1880.0,
        1750.0,
        60.0
      ],
      [
        -1870.0,
        1750.0,
        60.0
      ],
      [
        -1870.0,
        2000.0,
        60.0
      ],
      [
        -1880.0,
        2000.0,
        60.0
      ],
      [
        -1850.0001220703125,
        2000.0,
        0.0
      ],
      [
        -1880.0,
        1950.0,
        60.0
      ],
      [
        -1870.0,
        1950.0,
        60.0
      ],
      [
        -1548.7220458984375,
        694.0467529296875,
        60.000003814697266
      ],
      [
        -1449.9705810546875,
        93.32071685791016,
        60.0
      ],
      [
        -1850.0,
        2100.0,
        60.0
      ],
      [
        -1850.0,
        2000.0,
        60.0
      ],
      [
        -1850.0,
        1750.0,
        60.000003814697266
      ],
      [
        -1850.0,
        1330.0,
        60.0
      ],
      [
        -1850.0,
        1800.0,
        60.0
      ],
      [
        -1850.0,
        1800.0,
        0.0
      ],
      [
        -1850.0,
        1330.0,
        60.000003814697266
      ],
      [
        -1850.0,
        1750.0,
        60.0
      ],
      [
        -1850.0,
        1950.0,
        -0.000286102294921875
      ],
      [
        -1850.0,
        1950.0,
        59.999996185302734
      ],
      [
        -1850.0,
        2000.0,
        60.0
      ],
      [
        -1786.20068359375,
        652.488037109375,
        60.0
      ],
      [
        -1548.7220458984375,
        694.0467529296875,
        60.0
      ],
      [
        -1840.0,
        1800.0,
        60.0
      ],
      [
        -1840.0,
        1750.0,
        60.0
      ],
      [
        -1840.0,
        2000.0,
        60.0
      ],
      [
        -1840.0,
        1950.0,
        60.00000762939453
      ],
      [
        -1840.0,
        1800.0,
        60.0
      ],
      [
        -1840.0,
        1750.0,
        60.0
      ],
      [
        -1840.0,
        1950.0,
        59.999996185302734
      ],
      [
        -1840.0,
        2000.0,
        60.0
      ],
      [
        -1840.0,
        2100.0,
        12.137771606445312
      ],
      [
        -1850.0,
        2100.0,
        60.0
      ],
      [
        -1840.0,
        2100.0,
        60.0
      ],
      [
        -1762.0716552734375,
        2100.0,
        24.929786682128906
      ],
      [
        -1779.8421630859375,
        2100.0,
        60.0
      ],
      [
        -1758.0823974609375,
        2100.0,
        25.584632873535156
      ],
      [
        -1769.7081298828125,
        2100.0,
        60.0
      ],
      [
        -500.0,
        676.0741577148438,
        60.0
      ],
      [
        -635.3445434570312,
        1256.204833984375,
        60.0
      ],
      [
        -635.927734375,
        1249.881591796875,
        53.98613739013672
      ],
      [
        -635.927734375,
        1249.881591796875,
        53.98613739013672
      ],
      [
        -639.1258544921875,
        1215.207763671875,
        21.009002685546875
      ],
      [
        -619.38232421875,
        1099.7569580078125,
        0.0
      ],
      [
        -594.2252197265625,
        1079.9539794921875,
        60.0
      ],
      [
        -619.38232421875,
        1099.7569580078125,
        0.0
      ],
      [
        -619.4890747070312,
        1099.7149658203125,
        -0.34053924679756165
      ],
      [
        -608.0948486328125,
        1104.192626953125,
        60.0
      ],
      [
        -629.2988891601562,
        1195.0802001953125,
        60.0
      ],
      [
        -637.8748779296875,
        1193.661376953125,
        16.630029678344727
      ],
      [
        -1548.4259033203125,
        2100.0,
        60.0
      ],
      [
        -1850.0,
        2100.0,
        90.0
      ],
      [
        -1850.0,
        2000.0,
        90.0
      ],
      [
        -1850.0,
        1750.0,
        90.0
      ],
      [
        -1850.0,
        1330.0,
        90.0
      ],
      [
        -1987.4073486328125,
        1350.0,
        90.0
      ],
      [
        -2130.561767578125,
        1350.0,
        90.0
      ],
      [
        -1972.3970947265625,
        1350.0,
        60.000003814697266
      ],
      [
        -1971.6563720703125,
        1330.0,
        60.0
      ],
      [
        -2123.031005859375,
        1330.0,
        90.0
      ],
      [
        -1986.66650390625,
        1330.0,
        90.0
      ],
      [
        -1850.0,
        1330.0,
        90.0
      ],
      [
        -1870.0,
        1350.0,
        90.0
      ],
      [
        -1850.0,
        1950.0,
        59.999996185302734
      ],
      [
        -1880.0,
        1950.0,
        90.0
      ],
      [
        -1850.0,
        1950.0,
        90.0
      ],
      [
        -1850.0,
        2000.0,
        90.0
      ],
      [
        -1880.0,
        2000.0,
        90.0
      ],
      [
        -1850.0,
        2000.0,
        60.0
      ],
      [
        -1880.0,
        1750.0,
        90.0
      ],
      [
        -1850.0,
        1750.0,
        90.0
      ],
      [
        -1850.0,
        1750.0,
        60.0
      ],
      [
        -1880.0,
        1800.0,
        90.0
      ],
      [
        -1850.0,
        1800.0,
        60.0
      ],
      [
        -1850.0,
        1800.0,
        90.0
      ],
      [
        -1857.4696044921875,
        624.7376708984375,
        90.0
      ],
      [
        -1850.0,
        627.6529541015625,
        86.85479736328125
      ],
      [
        -1850.0,
        626.0469360351562,
        90.0
      ],
      [
        -1675.156982421875,
        656.6926879882812,
        90.0
      ],
      [
        -1561.06494140625,
        676.6588134765625,
        90.0
      ],
      [
        -1675.156982421875,
        656.6926879882812,
        90.0
      ],
      [
        -1779.8421630859375,
        2100.0,
        60.0
      ],
      [
        -1850.0,
        2100.0,
        90.0
      ],
      [
        -1795.04345703125,
        2100.0,
        90.0
      ],
      [
        -1840.0,
        1800.0,
        90.0
      ],
      [
        -1840.0,
        1750.0,
        90.0
      ],
      [
        -1840.0,
        2000.0,
        90.0
      ],
      [
        -1840.0,
        1950.0,
        90.0
      ],
      [
        -1840.0,
        1950.0,
        90.0
      ],
      [
        -1840.0,
        2000.0,
        90.0
      ],
      [
        -1840.0,
        1750.0,
        90.0
      ],
      [
        -1840.0,
        1800.0,
        90.0
      ],
      [
        -1850.0,
        1350.0,
        200.0
      ],
      [
        -1850.0,
        1350.0,
        90.0
      ],
      [
        -1850.0,
        2095.245361328125,
        200.0
      ],
      [
        -1850.0,
        2100.0,
        198.45751953125
      ],
      [
        -2128.88916015625,
        1886.0,
        200.0
      ],
      [
        -2100.0,
        2330.0,
        160.0
      ],
      [
        -2100.0,
        2280.0,
        160.0
      ],
      [
        -2100.0,
        2400.0,
        160.0
      ],
      [
        -2100.0,
        2350.0,
        160.0
      ],
      [
        -2100.0,
        2350.0,
        160.0
      ],
      [
        -2125.27783203125,
        2350.0,
        195.0
      ],
      [
        -2100.0,
        2280.0,
        160.0
      ],
      [
        -2125.27783203125,
        2280.0,
        195.0
      ],
      [
        -2170.0,
        1689.93310546875,
        184.90219116210938
      ],
      [
        -2195.0,
        1662.265869140625,
        184.90219116210938
      ],
      [
        -2350.0,
        1766.0,
        184.90219116210938
      ],
      [
        -2340.0,
        1766.0,
        184.90219116210938
      ],
      [
        -2350.0,
        1721.0,
        184.90219116210938
      ],
      [
        -2340.0,
        1766.0,
        184.90219116210938
      ],
      [
        -2340.0,
        1756.0,
        184.90219116210938
      ],
      [
        -2340.0,
        1831.0,
        184.90219116210938
      ],
      [
        -2350.0,
        1831.0,
        184.90219116210938
      ],
      [
        -2340.0,
        1831.0,
        184.90219116210938
      ],
      [
        -2340.0,
        1821.0,
        184.90219116210938
      ],
      [
        -2170.0,
        1689.93310546875,
        184.90219116210938
      ],
      [
        -2170.0,
        1689.5714111328125,
        187.75933837890625
      ],
      [
        -2170.0,
        1689.5714111328125,
        187.75933837890625
      ],
      [
        -2170.0,
        1689.5714111328125,
        194.90219116210938
      ],
      [
        -2350.0,
        1766.0,
        165.0
      ],
      [
        -2340.0,
        1766.0,
        165.0
      ],
      [
        -2350.0,
        1721.0,
        165.0
      ],
      [
        -2340.0,
        1766.0,
        165.0
      ],
      [
        -2340.0,
        1756.0,
        165.0
      ],
      [
        -2340.0,
        1831.0,
        165.0
      ],
      [
        -2350.0,
        1831.0,
        165.0
      ],
      [
        -2340.0,
        1831.0,
        165.0
      ],
      [
        -2340.0,
        1821.0,
        165.0
      ],
      [
        -2340.0,
        1721.0,
        155.0
      ],
      [
        -2260.0,
        1796.359375,
        163.2811737060547
      ],
      [
        -2260.0,
        1804.6666259765625,
        146.6666717529297
      ],
      [
        -2260.0,
        1804.6666259765625,
        146.6666717529297
      ],
      [
        -2270.0,
        1804.6666259765625,
        146.6666717529297
      ],
      [
        -2260.0,
        1610.0,
        107.99998474121094
      ],
      [
        -2260.0,
        1610.0,
        109.99998474121094
      ],
      [
        -2260.0,
        1600.0,
        112.0
      ],
      [
        -2260.0,
        1600.0,
        110.0
      ],
      [
        -2260.0,
        1737.5,
        132.5
      ],
      [
        -2260.0,
        1740.0,
        131.0
      ],
      [
        -2260.0,
        1732.5,
        132.5
      ],
      [
        -2260.0,
        1737.5,
        132.5
      ],
      [
        -2260.0,
        1752.5,
        132.5
      ],
      [
        -2260.0,
        1755.0,
        131.0
      ],
      [
        -2260.0,
        1747.5,
        132.5
      ],
      [
        -2260.0,
        1752.5,
        132.5
      ],
      [
        -2245.0,
        1804.6666259765625,
        146.6666717529297
      ],
      [
        -2250.0,
        1804.6666259765625,
        146.6666717529297
      ],
      [
        -2245.0,
        1793.9090576171875,
        130.0
      ],
      [
        -2250.0,
        1737.5,
        132.5
      ],
      [
        -2250.0,
        1740.0,
        131.0
      ],
      [
        -2250.0,
        1752.5,
        132.5
      ],
      [
        -2250.0,
        1755.0,
        131.0
      ],
      [
        -2245.0,
        1737.5,
        132.5
      ],
      [
        -2245.0,
        1740.0,
        131.0
      ],
      [
        -2245.0,
        1732.5,
        132.5
      ],
      [
        -2245.0,
        1737.5,
        132.5
      ],
      [
        -2245.0,
        1752.5,
        132.5
      ],
      [
        -2245.0,
        1755.0,
        131.0
      ],
      [
        -2245.0,
        1747.5,
        132.5
      ],
      [
        -2245.0,
        1752.5,
        132.5
      ],
      [
        -2240.0,
        1794.181640625,
        159.99969482421875
      ],
      [
        -2240.0,
        1798.0001220703125,
        159.9997100830078
      ],
      [
        -2240.0,
        1804.6666259765625,
        146.6666717529297
      ],
      [
        -2240.0,
        1804.6666259765625,
        146.6666717529297
      ],
      [
        -2246.0,
        1580.0,
        108.0
      ],
      [
        -2246.0,
        1575.0,
        103.0
      ],
      [
        -2246.0,
        1610.0,
        107.99998474121094
      ],
      [
        -2246.0,
        1610.0,
        102.99998474121094
      ],
      [
        -2246.0,
        1610.0,
        102.99998474121094
      ],
      [
        -2246.0,
        1610.0,
        96.4381103515625
      ],
      [
        -2246.0,
        1575.0,
        103.0
      ],
      [
        -2246.0,
        1575.0,
        101.27629852294922
      ],
      [
        -2260.0,
        1805.5,
        165.0
      ],
      [
        -2260.0,
        1810.3016357421875,
        155.3968963623047
      ],
      [
        -2260.0,
        1810.3016357421875,
        155.3968963623047
      ],
      [
        -2270.0,
        1810.3016357421875,
        155.3968963623047
      ],
      [
        -2240.0,
        1808.0001220703125,
        159.99974060058594
      ],
      [
        -2240.0,
        1810.3016357421875,
        155.3968963623047
      ],
      [
        -2240.0,
        1810.3016357421875,
        155.3968963623047
      ],
      [
        -2250.0,
        1810.3016357421875,
        155.3968963623047
      ],
      [
        -2240.0,
        1805.5,
        165.0
      ],
      [
        -2170.0,
        1866.0,
        155.0
      ],
      [
        -2170.0,
        1721.0,
        155.0
      ],
      [
        -2170.0,
        1856.0,
        105.0
      ],
      [
        -2170.0,
        1731.0,
        105.0
      ],
      [
        -2170.0,
        1731.0,
        105.0
      ],
      [
        -2170.0,
        1741.0,
        90.0
      ],
      [
        -2160.0,
        1831.0,
        184.90219116210938
      ],
      [
        -2170.0,
        1831.0,
        184.90219116210938
      ],
      [
        -2160.0,
        1721.0,
        184.90219116210938
      ],
      [
        -2170.0,
        1766.0,
        184.90219116210938
      ],
      [
        -2160.0,
        1766.0,
        184.90219116210938
      ],
      [
        -2160.0,
        1866.0,
        184.90219116210938
      ],
      [
        -2160.0,
        1831.0,
        172.85723876953125
      ],
      [
        -2170.0,
        1831.0,
        172.8572540283203
      ],
      [
        -2160.0,
        1741.0,
        90.0
      ],
      [
        -2064.453125,
        2036.0,
        110.78089141845703
      ],
      [
        -2064.453125,
        2186.0,
        110.78089141845703
      ],
      [
        -2064.453125,
        2186.0,
        110.78089904785156
      ],
      [
        -2064.453125,
        2216.0,
        110.78089141845703
      ],
      [
        -2064.453125,
        2111.0,
        110.78089141845703
      ],
      [
        -2064.453125,
        2111.0,
        110.78089904785156
      ],
      [
        -2064.453125,
        2141.0,
        110.78089141845703
      ],
      [
        -2064.453125,
        2066.0,
        110.78089141845703
      ],
      [
        -2064.453125,
        2036.0,
        110.78089904785156
      ],
      [
        -2064.453125,
        1916.0,
        110.78089904785156
      ],
      [
        -2064.453125,
        1886.0,
        110.78089141845703
      ],
      [
        -2064.453125,
        1886.0,
        110.78089904785156
      ],
      [
        -2064.453125,
        1916.0,
        110.78089141845703
      ],
      [
        -2064.453125,
        1961.0,
        110.78089141845703
      ],
      [
        -2064.453125,
        1961.0,
        110.78089904785156
      ],
      [
        -2064.453125,
        1991.0,
        110.78089141845703
      ],
      [
        -1880.0,
        1800.0,
        115.96772003173828
      ],
      [
        -1850.0,
        1800.0,
        90.0
      ],
      [
        -1850.0,
        1800.0,
        102.41931915283203
      ],
      [
        -1880.0,
        1750.0,
        115.96772003173828
      ],
      [
        -1850.0,
        1750.0,
        102.41931915283203
      ],
      [
        -1850.0,
        1750.0,
        90.0
      ],
      [
        -1880.0,
        2000.0,
        115.96772003173828
      ],
      [
        -1850.0,
        2000.0,
        90.0
      ],
      [
        -1850.0,
        2000.0,
        102.41931915283203
      ],
      [
        -1850.0,
        1950.0,
        90.0
      ],
      [
        -1880.0,
        1950.0,
        115.96772003173828
      ],
      [
        -1850.0,
        1950.0,
        102.41931915283203
      ],
      [
        -1850.0,
        1950.0,
        185.0
      ],
      [
        -1850.0,
        1800.0,
        185.0
      ],
      [
        -1850.0,
        2000.0,
        225.0
      ],
      [
        -1850.0,
        2000.0,
        185.0
      ],
      [
        -1850.0,
        1800.0,
        185.0
      ],
      [
        -1850.0,
        1800.0,
        225.0
      ],
      [
        -1850.0,
        1750.0,
        185.0
      ],
      [
        -1850.0,
        1750.0,
        225.0
      ],
      [
        -1850.0,
        1950.0,
        225.0
      ],
      [
        -1850.0,
        1950.0,
        185.0
      ],
      [
        -1850.7816162109375,
        2100.0,
        200.0
      ],
      [
        -1867.6728515625,
        2102.3271484375,
        232.58013916015625
      ],
      [
        -1867.990966796875,
        2117.990966796875,
        228.12619018554688
      ],
      [
        -1854.0693359375,
        2120.0,
        200.0
      ],
      [
        -1850.0,
        1950.0,
        185.0
      ],
      [
        -1850.0,
        1950.0,
        150.0
      ],
      [
        -1850.0,
        1950.0,
        150.0
      ],
      [
        -1853.78857421875,
        1950.0,
        104.13031768798828
      ],
      [
        -1850.0,
        2000.0,
        185.0
      ],
      [
        -1850.0,
        2000.0,
        150.0
      ],
      [
        -1850.0,
        2000.0,
        150.0
      ],
      [
        -1853.78857421875,
        2000.0,
        104.13031768798828
      ],
      [
        -1850.0,
        1750.0,
        150.0
      ],
      [
        -1850.0,
        1750.0,
        185.0
      ],
      [
        -1850.0,
        1750.0,
        150.0
      ],
      [
        -1853.78857421875,
        1750.0,
        104.13031768798828
      ],
      [
        -1850.0,
        1800.0,
        150.0
      ],
      [
        -1850.0,
        1800.0,
        185.0
      ],
      [
        -1850.0,
        1800.0,
        150.0
      ],
      [
        -1853.78857421875,
        1800.0,
        104.13031768798828
      ],
      [
        -1840.0,
        1950.0,
        225.0
      ],
      [
        -1840.0,
        1950.0,
        185.0
      ],
      [
        -1847.0106201171875,
        2000.0,
        225.0
      ],
      [
        -1840.0,
        2000.0,
        185.0
      ],
      [
        -1840.0,
        2000.0,
        211.16436767578125
      ],
      [
        -1850.0,
        2100.0,
        185.0
      ],
      [
        -1850.0,
        2100.0,
        198.45751953125
      ],
      [
        -1843.180908203125,
        2100.0,
        185.0
      ],
      [
        -1840.0,
        1750.0,
        185.0
      ],
      [
        -1840.0,
        1750.0,
        225.0
      ],
      [
        -1840.0,
        1800.0,
        185.0
      ],
      [
        -1840.0,
        1800.0,
        225.0
      ],
      [
        -1820.0,
        1950.0,
        187.91493225097656
      ],
      [
        -1820.0,
        1958.985107421875,
        185.0
      ],
      [
        -1838.791259765625,
        1950.0,
        225.0
      ],
      [
        -1820.0,
        1950.0,
        187.91493225097656
      ],
      [
        -1826.7423095703125,
        2000.0,
        185.0
      ],
      [
        -1840.0,
        1950.0,
        185.0
      ],
      [
        -1840.0,
        2000.0,
        185.0
      ],
      [
        -1840.0,
        1750.0,
        185.0
      ],
      [
        -1840.0,
        1800.0,
        185.0
      ],
      [
        -1820.0,
        1958.985107421875,
        185.0
      ],
      [
        -1823.573486328125,
        2000.0,
        178.74642944335938
      ],
      [
        -1823.573486328125,
        2000.0,
        178.74639892578125
      ],
      [
        -1826.7421875,
        2000.0,
        185.0
      ],
      [
        -1764.8831787109375,
        2341.45556640625,
        429.5688781738281
      ],
      [
        -1755.3116455078125,
        2362.681640625,
        429.10040283203125
      ],
      [
        -1690.302490234375,
        2333.830322265625,
        426.8799133300781
      ],
      [
        -1690.279541015625,
        2333.8203125,
        426.9466552734375
      ],
      [
        -1725.06005859375,
        2373.83203125,
        426.9512939453125
      ],
      [
        -1688.00927734375,
        2338.93994140625,
        426.9678039550781
      ],
      [
        -1726.93994140625,
        2306.168212890625,
        426.9510498046875
      ],
      [
        -1699.1546630859375,
        2359.758056640625,
        475.0
      ],
      [
        -1691.032470703125,
        2341.456787109375,
        475.0
      ],
      [
        -1691.4635009765625,
        2342.427978515625,
        485.0
      ],
      [
        -1698.7021484375,
        2358.73828125,
        485.0
      ],
      [
        -1691.032470703125,
        2341.456787109375,
        475.0
      ],
      [
        -1699.15478515625,
        2359.75830078125,
        475.0
      ],
      [
        -1698.7021484375,
        2358.738525390625,
        485.0
      ],
      [
        -1691.4635009765625,
        2342.427734375,
        485.0
      ],
      [
        -1693.446044921875,
        2346.895263671875,
        531.0
      ],
      [
        -1696.6204833984375,
        2354.048095703125,
        531.0
      ],
      [
        -1696.62060546875,
        2354.048095703125,
        531.0
      ],
      [
        -1693.446044921875,
        2346.895263671875,
        531.0
      ],
      [
        -1691.90673828125,
        2351.661376953125,
        537.6808471679688
      ],
      [
        -1694.5235595703125,
        2349.322998046875,
        556.0
      ],
      [
        -1695.4892578125,
        2351.498779296875,
        556.0
      ],
      [
        -1693.239501953125,
        2351.110107421875,
        550.3037719726562
      ],
      [
        -1698.7020263671875,
        2321.26171875,
        485.0
      ],
      [
        -1696.6204833984375,
        2325.9521484375,
        531.0
      ],
      [
        -1689.5648193359375,
        2350.4755859375,
        541.0
      ],
      [
        -1687.65087890625,
        2346.1630859375,
        541.0
      ],
      [
        -1687.65087890625,
        2346.1630859375,
        541.0
      ],
      [
        -1689.5648193359375,
        2350.4755859375,
        541.0
      ],
      [
        -1696.6878662109375,
        2317.318359375,
        429.10174560546875
      ],
      [
        -1680.0238037109375,
        2326.370849609375,
        460.0
      ],
      [
        -1696.6883544921875,
        2317.318359375,
        429.10040283203125
      ],
      [
        -1698.7020263671875,
        2321.26171875,
        485.0
      ],
      [
        -1679.344970703125,
        2327.900390625,
        475.0
      ],
      [
        -1680.0238037109375,
        2326.370849609375,
        460.0
      ],
      [
        -1679.344970703125,
        2327.900390625,
        475.0
      ],
      [
        -1685.81103515625,
        2337.982421875,
        541.0
      ],
      [
        -1689.564697265625,
        2329.5244140625,
        541.0
      ],
      [
        -1695.4891357421875,
        2328.501220703125,
        556.0
      ],
      [
        -1690.3514404296875,
        2340.0,
        555.9052124023438
      ],
      [
        -1696.6204833984375,
        2325.9521484375,
        531.0
      ],
      [
        -1689.564697265625,
        2329.5244140625,
        541.0
      ],
      [
        -1685.81103515625,
        2337.982421875,
        541.0
      ],
      [
        -1690.3603515625,
        2340.0,
        531.0468139648438
      ],
      [
        -1690.3514404296875,
        2340.0,
        555.9052124023438
      ],
      [
        -1690.3802490234375,
        2340.012939453125,
        555.96875
      ],
      [
        -1690.3603515625,
        2340.0,
        531.0468139648438
      ],
      [
        -1690.3818359375,
        2340.009521484375,
        531.015380859375
      ],
      [
        -1724.361328125,
        2309.22998046875,
        475.0
      ],
      [
        -1723.2686767578125,
        2309.65234375,
        485.0
      ],
      [
        -1724.361328125,
        2309.22998046875,
        475.0
      ],
      [
        -1723.2686767578125,
        2309.65234375,
        485.0
      ],
      [
        -1718.2432861328125,
        2311.59521484375,
        531.0
      ],
      [
        -1680.0235595703125,
        2326.37158203125,
        475.0
      ],
      [
        -1680.0235595703125,
        2326.37158203125,
        475.0
      ],
      [
        -1693.22998046875,
        2321.265869140625,
        541.0
      ],
      [
        -1693.22998046875,
        2321.265869140625,
        541.0
      ],
      [
        -1695.2647705078125,
        2316.680908203125,
        541.0
      ],
      [
        -1695.2647705078125,
        2316.680908203125,
        541.0
      ],
      [
        -1710.2177734375,
        2309.33740234375,
        541.0
      ],
      [
        -1715.5120849609375,
        2312.651123046875,
        556.0
      ],
      [
        -1718.2432861328125,
        2311.59521484375,
        531.0
      ],
      [
        -1710.2177734375,
        2309.33740234375,
        541.0
      ],
      [
        -1752.8453369140625,
        2320.241943359375,
        475.0
      ],
      [
        -1753.2979736328125,
        2321.26171875,
        485.0
      ],
      [
        -1752.8453369140625,
        2320.241943359375,
        475.0
      ],
      [
        -1753.2978515625,
        2321.26171875,
        485.0
      ],
      [
        -1755.379638671875,
        2325.9521484375,
        531.0
      ],
      [
        -1761.6485595703125,
        2340.0,
        555.9052124023438
      ],
      [
        -1761.60546875,
        2339.98095703125,
        556.0
      ],
      [
        -1761.6077880859375,
        2339.98583984375,
        531.0
      ],
      [
        -1761.6396484375,
        2340.0,
        531.0468139648438
      ],
      [
        -1762.4354248046875,
        2329.52490234375,
        541.0
      ],
      [
        -1756.5108642578125,
        2328.50146484375,
        556.0
      ],
      [
        -1755.3795166015625,
        2325.9521484375,
        531.0
      ],
      [
        -1762.4354248046875,
        2329.52490234375,
        541.0
      ],
      [
        -1758.769775390625,
        2321.265380859375,
        541.0
      ],
      [
        -1758.769775390625,
        2321.265380859375,
        541.0
      ],
      [
        -1719.0673828125,
        2305.916015625,
        541.0
      ],
      [
        -1719.0673828125,
        2305.916015625,
        541.0
      ],
      [
        -1727.800537109375,
        2303.931884765625,
        541.0
      ],
      [
        -1727.80029296875,
        2303.931884765625,
        541.0
      ],
      [
        -1723.2685546875,
        2370.34765625,
        485.0
      ],
      [
        -1718.2431640625,
        2368.40478515625,
        531.0
      ],
      [
        -1693.2301025390625,
        2358.734375,
        541.0
      ],
      [
        -1693.2301025390625,
        2358.734375,
        541.0
      ],
      [
        -1705.201171875,
        2379.4443359375,
        460.0
      ],
      [
        -1712.729736328125,
        2377.5458984375,
        448.0195617675781
      ],
      [
        -1724.802734375,
        2374.49755859375,
        428.85382080078125
      ],
      [
        -1712.729736328125,
        2377.5458984375,
        448.0194396972656
      ],
      [
        -1699.848876953125,
        2361.29345703125,
        485.0
      ],
      [
        -1723.268798828125,
        2370.34765625,
        485.0
      ],
      [
        -1703.5623779296875,
        2378.810791015625,
        475.0
      ],
      [
        -1694.4337158203125,
        2375.28173828125,
        475.0
      ],
      [
        -1705.201171875,
        2379.4443359375,
        460.0
      ],
      [
        -1694.4337158203125,
        2375.28173828125,
        475.0
      ],
      [
        -1703.5623779296875,
        2378.810791015625,
        475.0
      ],
      [
        -1710.218017578125,
        2370.66259765625,
        541.0
      ],
      [
        -1698.08056640625,
        2365.97021484375,
        541.0
      ],
      [
        -1699.892822265625,
        2361.310302734375,
        556.0
      ],
      [
        -1715.51220703125,
        2367.348876953125,
        556.0
      ],
      [
        -1718.2431640625,
        2368.40478515625,
        531.0
      ],
      [
        -1699.8773193359375,
        2361.304443359375,
        531.0
      ],
      [
        -1698.08056640625,
        2365.97021484375,
        541.0
      ],
      [
        -1710.2181396484375,
        2370.662841796875,
        541.0
      ],
      [
        -1698.0302734375,
        2365.95068359375,
        541.0
      ],
      [
        -1698.0302734375,
        2365.95068359375,
        541.0
      ],
      [
        -1705.201416015625,
        2379.444580078125,
        475.0
      ],
      [
        -1705.201416015625,
        2379.444580078125,
        475.0
      ],
      [
        -1719.0670166015625,
        2374.083740234375,
        541.0
      ],
      [
        -1719.06689453125,
        2374.083740234375,
        541.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.3703444004058838,
        0.8832541108131409,
        0.2875887453556061
      ],
      "plane_d": 4875.60302734375,
      "bbox_min": [
        -3461.15576171875,
        -5122.0185546875,
        1040.098388671875
      ],
      "bbox_max": [
        -2147.99658203125,
        -4521.4228515625,
        1390.116943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001831054688,
      "bbox_min": [
        -4128.15283203125,
        -3334.0634765625,
        246.10055541992188
      ],
      "bbox_max": [
        7602.89599609375,
        -1140.9091796875,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8395622968673706,
        0.49151238799095154,
        0.231409952044487
      ],
      "plane_d": 4493.8125,
      "bbox_min": [
        -4128.15283203125,
        -2759.122802734375,
        1395.3641357421875
      ],
      "bbox_max": [
        -4123.98779296875,
        -2748.399658203125,
        1403.0306396484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06764065474271774,
        0.8608478903770447,
        0.5043467879295349
      ],
      "plane_d": 1372.294189453125,
      "bbox_min": [
        2400.0,
        -2050.0,
        7.19039249420166
      ],
      "bbox_max": [
        7669.3662109375,
        -806.7422485351562,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.19509035348892212,
        0.0
      ],
      "plane_d": 7679.38916015625,
      "bbox_min": [
        7484.2607421875,
        -1737.3270263671875,
        526.8804931640625
      ],
      "bbox_max": [
        7569.6552734375,
        -1308.022216796875,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04531257599592209,
        0.41337791085243225,
        0.9094314575195312
      ],
      "plane_d": 354.41241455078125,
      "bbox_min": [
        2962.535400390625,
        -1390.916015625,
        7.19039249420166
      ],
      "bbox_max": [
        7669.3662109375,
        -806.7422485351562,
        606.4027709960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.19509035348892212,
        0.0
      ],
      "plane_d": 7679.38916015625,
      "bbox_min": [
        7560.7802734375,
        -1352.6395263671875,
        7.19039249420166
      ],
      "bbox_max": [
        7669.3662109375,
        -806.7422485351562,
        601.8455810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.19509035348892212,
        0.0
      ],
      "plane_d": 7679.38916015625,
      "bbox_min": [
        7560.24072265625,
        -1355.351806640625,
        600.3306274414062
      ],
      "bbox_max": [
        7561.4580078125,
        -1349.2322998046875,
        606.4027709960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.19509035348892212,
        0.0
      ],
      "plane_d": 7679.38916015625,
      "bbox_min": [
        7486.08837890625,
        -1728.1380615234375,
        600.01513671875
      ],
      "bbox_max": [
        7561.59912109375,
        -1348.522705078125,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.19509035348892212,
        0.0
      ],
      "plane_d": 7679.38916015625,
      "bbox_min": [
        -4022.8212890625,
        -2564.65576171875,
        6.103515625e-05
      ],
      "bbox_max": [
        7671.36669921875,
        -796.68505859375,
        1733.090087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9449668526649475,
        0.08389011770486832,
        0.3162277042865753
      ],
      "plane_d": -187.74609375,
      "bbox_min": [
        140.185791015625,
        4947.96533203125,
        -300.0
      ],
      "bbox_max": [
        5713.9326171875,
        7267.0830078125,
        89.7060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        2769.303955078125,
        1194.52685546875,
        -22.699951171875
      ],
      "bbox_max": [
        7532.55712890625,
        7185.4150390625,
        1954.7119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        -0.19509035348892212,
        -0.0
      ],
      "plane_d": 7620.86181640625,
      "bbox_min": [
        3052.0458984375,
        1194.52685546875,
        -22.699951171875
      ],
      "bbox_max": [
        7532.55712890625,
        6882.69287109375,
        877.620361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7007350325584412,
        0.5362348556518555,
        0.4705556631088257
      ],
      "plane_d": 762.2274780273438,
      "bbox_min": [
        -4465.9453125,
        -876.36376953125,
        -300.0
      ],
      "bbox_max": [
        7800.0,
        7450.0,
        1961.4566650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7753851413726807,
        -0.028329361230134964,
        0.6308528780937195
      ],
      "plane_d": 2269.93212890625,
      "bbox_min": [
        2026.0242919921875,
        -876.36376953125,
        -291.4855651855469
      ],
      "bbox_max": [
        7800.0,
        4186.60400390625,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5601329803466797,
        0.06843777745962143,
        0.8255710005760193
      ],
      "plane_d": 1309.8272705078125,
      "bbox_min": [
        2951.8466796875,
        -876.36376953125,
        60.0
      ],
      "bbox_max": [
        7800.0,
        3209.21142578125,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.023366007953882217,
        -0.9992454648017883,
        -0.031025884672999382
      ],
      "plane_d": 4340.42333984375,
      "bbox_min": [
        -652.163818359375,
        4328.8857421875,
        -15.733333587646484
      ],
      "bbox_max": [
        -646.9763793945312,
        4329.27783203125,
        -14.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18527288734912872,
        -0.9232301712036133,
        -0.33663034439086914
      ],
      "plane_d": 3871.016845703125,
      "bbox_min": [
        -670.860107421875,
        4328.2587890625,
        -14.0
      ],
      "bbox_max": [
        -652.163818359375,
        4332.6376953125,
        -4.477063179016113
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2631174325942993,
        0.0,
        -0.964763879776001
      ],
      "plane_d": -183.48056030273438,
      "bbox_min": [
        -654.8818359375,
        4270.0,
        -14.0
      ],
      "bbox_max": [
        -646.0,
        4274.037109375,
        -11.198089599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18527288734912872,
        -0.9232301712036133,
        -0.33663034439086914
      ],
      "plane_d": 3871.016845703125,
      "bbox_min": [
        -672.5657958984375,
        4270.0,
        -14.530357360839844
      ],
      "bbox_max": [
        -653.7052612304688,
        4333.1435546875,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 4270.0,
      "bbox_min": [
        -657.8714599609375,
        4270.0,
        -11.836567878723145
      ],
      "bbox_max": [
        -653.7052612304688,
        4270.0,
        -9.770984649658203
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33586183190345764,
        -0.18472400307655334,
        -0.9236200451850891
      ],
      "plane_d": 558.8740844726562,
      "bbox_min": [
        -660.0845947265625,
        4274.037109375,
        -12.13838005065918
      ],
      "bbox_max": [
        -654.8818359375,
        4280.0,
        -10.429865837097168
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18527288734912872,
        -0.9232301712036133,
        -0.33663034439086914
      ],
      "plane_d": 3871.016845703125,
      "bbox_min": [
        -674.8861083984375,
        4328.01611328125,
        -14.449110984802246
      ],
      "bbox_max": [
        -667.93798828125,
        4333.56201171875,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 4270.0,
      "bbox_min": [
        -660.1070556640625,
        4270.0,
        -10.762322425842285
      ],
      "bbox_max": [
        -657.6298217773438,
        4270.0,
        -8.958085060119629
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3417430818080902,
        -0.0,
        0.9397934675216675
      ],
      "plane_d": 233.9231414794922,
      "bbox_min": [
        -678.0,
        4180.0,
        -42.48577880859375
      ],
      "bbox_max": [
        -659.8652954101562,
        4327.26806640625,
        -6.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 4270.0,
      "bbox_min": [
        -668.0,
        4270.0,
        -10.152623176574707
      ],
      "bbox_max": [
        -659.8652954101562,
        4270.0,
        -6.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9906212091445923,
        -0.13663740456104279,
        0.0
      ],
      "plane_d": -132.2821044921875,
      "bbox_min": [
        -838.5,
        5082.0,
        242.0
      ],
      "bbox_max": [
        -834.5,
        5111.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": -485.7258605957031,
      "bbox_min": [
        -572.9041748046875,
        632.4712524414062,
        -182.7124786376953
      ],
      "bbox_max": [
        -521.8115234375,
        959.0679321289062,
        -18.599721908569336
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        -0.19509035348892212,
        -0.0
      ],
      "plane_d": 7620.86181640625,
      "bbox_min": [
        7645.78857421875,
        -150.0,
        616.764892578125
      ],
      "bbox_max": [
        7800.0,
        625.27197265625,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        0.19509035348892212,
        0.0
      ],
      "plane_d": 7679.38916015625,
      "bbox_min": [
        -469.004638671875,
        -1091.6004638671875,
        -171.80690002441406
      ],
      "bbox_max": [
        7800.0,
        467.8068542480469,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853102684021,
        -0.19509035348892212,
        -0.0
      ],
      "plane_d": 7620.86181640625,
      "bbox_min": [
        -469.004638671875,
        -150.0,
        -171.80690002441406
      ],
      "bbox_max": [
        7800.0,
        467.8068542480469,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1542341560125351,
        0.8799495697021484,
        0.4493335783481598
      ],
      "plane_d": -876.6629028320312,
      "bbox_min": [
        -1881.21875,
        615.4686279296875,
        90.0
      ],
      "bbox_max": [
        -1561.06494140625,
        676.6588134765625,
        100.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}